import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableHead from "@material-ui/core/TableHead";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import {Grid, Modal, NativeSelect, IconButton, Button, Dialog} from "@material-ui/core";
import moment from 'moment';
import CancelIcon from "@material-ui/icons/Clear";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import TextsmsOutlinedIcon from '@material-ui/icons/TextsmsOutlined';
import {
    getOrder,
    deleteOrder,
    updateOrder,
    sendMail,
    printReceipt,
    sendMessage,
    saveOnlineOrderMessage,
    stripeRefund
} from '../../../Actions/orderAction';
import './Orders.css';
import SlidingPanel from 'react-sliding-side-panel';
import Alert from "../../../Helper/SimpleAlert/alert";
import isEqual from "lodash.isequal";
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import {audioFunc} from "../../../Service/helper";
import FullScreenNotification from '../../../Helper/FullScreenNotification/FullScreenNotification';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import {TablePaginationActionsWrapped} from "../../../Helper/Pagination/pagination";
import Loader from "../../../Helper/loader/loader";

const momentTz = require('moment-timezone');

const styles=theme=>({
    progress: {
        margin: theme.spacing.unit * 2,
    },

    table: {
        minWidth: 200,
    },

    tableRow: {
        height:45,
        fontSize:'15px',
    },

    tableHeader:{
        fontSize:'0.9em!important',
        fontWeight: '500 !important',
        verticalAlign: 'middle',
        width:'10%',
        textAlign:'center !important',
    },

    tableCell:{
        textAlign:'center',
        fontSize:'1.0em!important',
        verticalAlign: 'middle',
        width:'10%',
    },

    preparebyWithEditDiv:{
        textAlign:'center',
        fontSize:'1.0em!important',
        verticalAlign: 'middle',
        display:'flex',
        flexDirection:'row'
    },

    tableHeaderCell:{
        textAlign:'center',
        fontSize:'1.0em!important',
        verticalAlign: 'middle',
        width:'10%',
        color: 'white !important',
        backgroundColor : '#563c5c',
    },

    orderDetailHeaderCell:{
        fontSize:'1.0em!important',
        verticalAlign: 'middle',
        width:'10%',
        borderBottom: '1px solid gray',
        borderTop: '1px solid gray',
        color : 'white',
        textAlign:'right'
    },

    orderDetailHeaderItemDescriptionCell:{
        fontSize:'1.0em!important',
        verticalAlign: 'middle',
        width:'10%',
        borderBottom: '1px solid gray',
        borderTop: '1px solid gray',
        color : 'white',
    },

    orderDetailCell:{
        fontSize:'1.0em!important',
        verticalAlign: 'middle',
        width:'40%',
        borderBottom: '1px solid gray',
        borderTop: '1px solid gray'
    },

    orderDetailCellTextAlign:{
        fontSize:'1.0em!important',
        verticalAlign: 'middle',
        width:'10%',
        borderBottom: '1px solid gray',
        borderTop: '1px solid gray',
        textAlign: 'right'
    },

    subtotalCellTextAlign:{
        fontSize:'1.0em!important',
        verticalAlign: 'middle',
        width:'10%',
        textAlign: '-webkit-right',
    },

    taxTotalCellTextAlign:{
        fontSize:'1.0em!important',
        verticalAlign: 'middle',
        width:'10%',
        textAlign: '-webkit-right',
        fontWeight: '100'
    },

    select: {
        height:'20px',
        backgroundColor:'#f1f1f1',
        fontSize:'14px',
        padding: '5px',
        marginTop: '5px',
        display : 'inline-block'
    },

    slidingPanel: {
        overflow : 'hidden',
    },

    btnSave: {
        margin: "10px",
        padding: "10px",
        border: "1px solid #851679 !important",
        fontSize: "17px !important",
        marginTop: "10px !important",
        backgroundColor: "#851679 !important",
        color: "#fff !important",
        height: "40px"
    },

    headerDate:{
        fontSize: '11px',
        // marginTop:'5px',
        textAlign:'center',
        width:'150px'
    },
});

// class CustomerReceiptToPrint extends React.Component {
//
//     state = {
//         order: this.props.order,
//         openPanel: this.props.openPanel,
//         selectedOrderDetail: this.props.selectedOrderDetail
//     };
//
//     render() {
//         const { classes, user } = this.props;
//         const { order, openPanel, selectedOrderDetail } = this.state;
//
//         var totalAmount  = 0
//         {
//             order && order.length > 0 &&
//             order.slice(0, order.length).map((data, index) => {
//                 let obj = this.state.order[index].answers;
//
//                 Object.keys(obj).map(function (key) {
//                     if (obj[key].name === "total") {
//                         var SampleText =obj[key].answer.toString();
//                         var NewText = SampleText.replace("$", "");
//                         totalAmount = totalAmount + Number(NewText)
//                         totalAmount =   +totalAmount.toFixed(2);
//                     }
//                 })
//             })
//         }
//
//         return(
//             // <div id={this.props.printableId} style={{width:'300px'}}>
//             <div id={this.props.printableId} className='customerPrintme' style={{ display: "none" }}>
//                 {order && order.length > 0 && selectedOrderDetail && order.slice(0, 1).map((order, index,key) => {
//                     let obj = selectedOrderDetail.answers;
//
//                     let isactiveOrCompleted = ""
//
//                     let orderType = ""
//
//                     let created_date = moment.utc(selectedOrderDetail.created_at).format('ddd, MMM Do');
//                     let created_time = moment.utc(selectedOrderDetail.created_at).format('h:mm A');
//
//                     let customer = ""
//                     let deliveryAddress = ""
//                     let deliveryAddress2 = ""
//                     let address2 = ""
//                     let state = ""
//                     let city = ""
//                     let postal = ""
//                     let phonenumber = ""
//                     let email = ""
//
//                     let foodInstructions = ""
//                     let deliveryInstructions = ""
//
//                     let orderDetails = []
//
//                     let subTotal = ""
//                     let tax = ""
//                     let tip = ""
//                     let total = "-"
//
//                     let prepare_by_date = ""
//                     let prepare_by_time = "-"
//
//                     Object.keys(obj).map(function (key) {
//                         if (obj[key].name === "name") {
//                             customer = obj[key].prettyFormat;
//                         }
//                         else if (obj[key].name === "deliveryAddress") {
//                             if (obj[key].answer !== undefined && obj[key].answer !== "") {
//                                 if (obj[key].answer["addr_line1"] !== "" && obj[key].answer["addr_line1"] !== undefined) {
//                                     deliveryAddress = obj[key].answer["addr_line1"]
//                                 }
//                                 deliveryAddress2 = obj[key].answer["addr_line2"]
//                                 state = obj[key].answer["state"]
//                                 city = obj[key].answer["city"]
//                                 postal = obj[key].answer["postal"]
//                                 if (deliveryAddress2 !== "") {
//                                     address2 = deliveryAddress2
//                                 }
//                                 if (city !== "") {
//                                     address2 = address2 !== "" ? address2 + ', ' + city : city
//                                 }
//                                 if (state !== "") {
//                                     address2 = address2 !== "" ? address2 + ', ' + state : state
//                                 }
//                                 if (postal !== "") {
//                                     address2 = address2 !== "" ? address2 + ' ' + postal : postal
//                                 }
//                             }
//                         }
//                         else if (obj[key].name === "phoneNumber") {
//                             phonenumber = obj[key].prettyFormat
//                         }
//                         else if (obj[key].name === "email") {
//                             email = obj[key].answer
//                         }
//                         else if (obj[key].name === "foodInstructions") {
//                             foodInstructions = obj[key].answer
//                         }
//                         else if (obj[key].name === "deliveryInstructions") {
//                             deliveryInstructions = obj[key].answer
//                         }
//                         else if (obj[key].name === "orderDetails") {
//                             let obj1 = obj[key].answer
//                             orderDetails.push({
//                                 obj1
//                             })
//                             // orderDetails = obj[key].answer
//                         }
//                         else if (obj[key].name === "pickupdelivery") {
//                             orderType = obj[key].answer
//                         }
//                         else if (obj[key].name === "total") {
//                             total = obj[key].answer
//                         }
//                         else if (obj[key].name === "isactiveorcompleted") {
//                             isactiveOrCompleted = obj[key].answer;
//                         }
//                     })
//
//                     return (
//                         // margin:'auto',alignContent:"center"
//                         <div style={{width:"350px", alignContent:"center", margin:"auto"}}>
//                             <div>
//                                 <div style={{marginTop:'10px', width:'100%'}}>
//                                     <div style={{textAlign:"center"}}>
//                                         <label style={{fontSize:'30px',fontWeight:'bold', height:'60px'}}>{user.AppUser.FirstName}</label>
//                                     </div>
//                                     <div style={{textAlign:"center"}}>
//                                         <label style={{fontSize:'30px', height:'60px'}}>{user.BusinessUser.Address}</label>
//                                     </div>
//                                     <div style={{textAlign:"center"}}>
//                                         <label style={{fontSize:'30px', height:'60px'}}>{user.AppUser.PhoneNo}</label>
//                                     </div>
//                                     <div style={{marginTop: '30px', textAlign:"center"}}>
//                                         <label style={{fontSize:'30px',fontWeight:'bold', height:'60px'}}>{orderType}</label>
//                                     </div>
//                                     <div style={{marginTop: '20px'}}>
//                                         <label style={{fontSize: '16px', fontWeight: 'normal', height: '20px'}}>{created_date} - {created_time} </label>
//                                     </div>
//                                     <div  style={{marginTop: '20px'}}>
//                                         <div>
//                                             <label style={{fontSize:'0.5em!important',fontWeight:'bold', height:'20px'}}> {customer} </label>
//                                         </div>
//                                         {deliveryAddress !== ""  && deliveryAddress !== undefined ?
//                                             <div>
//                                                 <label style={{fontSize: '16px', fontWeight:'normal', height: '20px'}}>{deliveryAddress}</label>
//                                             </div>
//                                             :
//                                             ""
//                                         }
//                                         {address2 !== "" && address2 !== undefined ?
//                                             <div>
//                                                 <label style={{fontSize: '16px', fontWeight:'normal', height: '20px'}}>{address2}</label>
//                                             </div>
//                                             :
//                                             phonenumber !== "" && phonenumber !== undefined ?
//                                                 <div>
//                                                     <label style={{fontSize: '16px', fontWeight: 'normal', height: '20px'}}>{phonenumber}</label>
//                                                 </div>
//                                                 : ""
//                                         }
//                                         {address2 !== "" && address2 !== undefined ?
//                                             phonenumber !== "" && phonenumber !== undefined ?
//                                                 <div>
//                                                     <label style={{fontSize: '16px', fontWeight:'normal', height: '20px'}}>{phonenumber}</label>
//                                                 </div>
//                                                 : ""
//                                             : ""
//                                         }
//                                     </div>
//                                 </div>
//                                 {deliveryInstructions !== "" && deliveryInstructions !== undefined ?
//                                     <div style={{marginTop: '20px'}}>
//                                         <div>
//                                             <label style={{fontSize:'0.5em!important', fontWeight:'bold', height: '20px'}}> Delivery Instructions: </label>
//                                         </div>
//                                         <div>
//                                             <label style={{fontSize: '16px', fontWeight:'normal', height: '20px'}} dangerouslySetInnerHTML={{__html: deliveryInstructions}}></label>
//                                         </div>
//                                     </div> : ""
//                                 }
//                                 {foodInstructions !== "" && foodInstructions !== undefined ?
//                                     <div style={{marginTop: '20px'}}>
//                                         <div>
//                                             <label style={{fontSize:'0.5em!important', fontWeight:'bold', height: '20px', color:'red'}}> Food Instructions: </label>
//                                         </div>
//                                         <div>
//                                             <label style={{fontSize: '16px', fontWeight:'normal', height: '20px'}} dangerouslySetInnerHTML={{__html: foodInstructions}}></label>
//                                         </div>
//                                     </div> : ""
//                                 }
//                                 {orderDetails.map((orderDetailsObj, index) => {
//                                     let obj2 = orderDetails[index]["obj1"];
//
//                                     let arrPayment = JSON.parse(obj2["paymentArray"])
//
//                                     if (arrPayment !== "" && arrPayment !== undefined){
//                                         if (arrPayment.subtotal !== undefined) {
//                                             subTotal = (Math.round(arrPayment.subtotal * 100) / 100).toFixed(2)
//                                         }
//                                         if (arrPayment.tax !== undefined) {
//                                             tax = (Math.round(arrPayment.tax * 100) / 100).toFixed(2)
//                                         }
//                                     }
//
//                                     return (
//                                         <div style={{marginTop: '20px'}}>
//                                             <Table style={{border:'none', width:'100%'}}>
//                                                 {/*<TableHead>*/}
//                                                 {/*    <TableRow style ={{height:45, fontSize:'15px', }} id='descriptionQuantityPrice'>*/}
//                                                 {/*        <TableCell style={{ fontSize:'1.0em!important', verticalAlign: 'middle',  width:'10%',  borderBottom: '1px solid gray', color : 'black', fontWeight:'bold', textAlign: 'left'}}>*/}
//                                                 {/*            Item Description*/}
//                                                 {/*        </TableCell>*/}
//                                                 {/*        <TableCell style ={{ fontSize:'1.0em!important', verticalAlign: 'middle', width:'10%', borderBottom: '1px solid gray', color : 'black', fontWeight:'bold', textAlign: 'right'}}>*/}
//                                                 {/*            Quantity*/}
//                                                 {/*        </TableCell>*/}
//                                                 {/*        <TableCell style ={{ fontSize:'1.0em!important', verticalAlign: 'middle', width:'10%', borderBottom: '1px solid gray', color : 'black', fontWeight:'bold', textAlign: 'right'}}>*/}
//                                                 {/*            Price*/}
//                                                 {/*        </TableCell>*/}
//                                                 {/*    </TableRow>*/}
//                                                 {/*</TableHead>*/}
//                                                 <TableBody>
//                                                     {Object.keys(obj2).map(function (key) {
//                                                         let data = JSON.parse(obj2[key])
//
//                                                         if (data.name === "Tip" && data.options !== undefined && data.options !== "") {
//                                                             var SampleText =data.options[0].selected.toString();
//                                                             var NewText = SampleText.replace("$", "");
//                                                             tip = (Math.round(NewText * 100) / 100).toFixed(2)
//                                                         }
//
//                                                         if (data !== "" && data !== undefined && data.name !== "" && data.name !== undefined && data.name !== "Tip") {
//                                                             return (
//                                                                 <TableRow style ={{height:45, fontSize:'15px', marginTop:'15px' }}>
//                                                                     <TableCell style={{fontSize:'1.0em!important', width:'10%', fontWeight:'bold',verticalAlign: 'top' }}>
//                                                                         {data.quantity}
//                                                                     </TableCell>
//                                                                     <TableCell style={{ fontSize:'1.0em!important', verticalAlign: 'top', width:'35%', fontWeight:'bold'}}>
//                                                                         <div>
//                                                                             {data.name}
//                                                                             {Object.keys(data.options).map(function (key) {
//                                                                                 let dataOptions = data.options[key] //JSON.parse()
//
//                                                                                 if (dataOptions.name !== "Quantity") {
//                                                                                     return (<div style={{marginLeft:'5px', fontWeight:'lighter'}}>
//                                                                                         {dataOptions.selected}
//                                                                                     </div>)
//                                                                                 }
//                                                                             })
//                                                                             }
//                                                                         </div>
//                                                                     </TableCell>
//                                                                     <TableCell style={{fontSize:'1.0em!important', width:'10%', textAlign: 'right', fontWeight:'bold', verticalAlign: 'top'}}>
//                                                                         ${(Math.round(data.price * 100) / 100).toFixed(2)}
//                                                                     </TableCell>
//                                                                 </TableRow>
//                                                             )
//                                                         }
//                                                     })
//                                                     }
//                                                 </TableBody>
//                                             </Table>
//                                         </div>
//                                     )
//                                 })
//                                 }
//                                 <div style ={{marginTop: '20px'}}>
//                                     <Table style={{minWidth: 200}}>
//                                         <TableHead>
//                                             <TableRow style={{height:26, fontSize:'15px'}}>
//                                                 <TableCell style={{fontSize:'20px', verticalAlign: 'middle', width:'10%',fontWeight:'bold', float : 'left'}}>
//                                                     Tip
//                                                 </TableCell>
//                                                 <TableCell style={{fontSize:'20px', verticalAlign: 'middle', width:'10%', textAlign: '-webkit-right',fontWeight:'bold'}}>
//                                                     ${tip}
//                                                 </TableCell>
//                                             </TableRow>
//                                         </TableHead>
//                                         {subTotal !== "" && subTotal !== undefined ?
//                                             <TableHead>
//                                                 <TableRow  style={{height:26, fontSize:'15px'}}>
//                                                     <TableCell style={{fontSize:'20px', verticalAlign: 'middle', width:'10%',fontWeight:'bold', float : 'left'}}>
//                                                         Subtotal
//                                                     </TableCell>
//                                                     <TableCell style={{fontSize:'20px', verticalAlign: 'middle', width:'10%', textAlign: '-webkit-right',fontWeight:'bold'}}>
//                                                         ${subTotal}
//                                                     </TableCell>
//                                                 </TableRow>
//                                             </TableHead> : ""
//                                         }
//                                         {tax !== "" && tax !== undefined ?
//                                             <TableHead>
//                                                 <TableRow style={{height:26, fontSize:'15px'}}>
//                                                     <TableCell style={{fontSize:'20px', verticalAlign: 'middle', width:'10%',fontWeight:'bold', float : 'left'}}>
//                                                         Taxes
//                                                     </TableCell>
//                                                     <TableCell style={{fontSize:'20px', verticalAlign: 'middle', width:'10%', textAlign: '-webkit-right',fontWeight:'bold'}}>
//                                                         ${tax}
//                                                     </TableCell>
//                                                 </TableRow>
//                                             </TableHead> : ""
//                                         }
//                                         <TableHead>
//                                             <TableRow style={{height:26, fontSize:'15px'}}>
//                                                 <TableCell style={{fontSize:'20px', verticalAlign: 'middle', width:'10%',fontWeight:'bold', float : 'left'}}>
//                                                     Total
//                                                 </TableCell>
//                                                 <TableCell style={{fontSize:'20px', verticalAlign: 'middle', width:'10%', textAlign: '-webkit-right',fontWeight:'bold'}}>
//                                                     {total}
//                                                 </TableCell>
//                                             </TableRow>
//                                         </TableHead>
//                                     </Table>
//                                 </div>
//                             </div>
//                         </div>
//                     )
//                 })
//                 }
//             </div>
//         )
//     }
// }

// class KitchenReceiptToPrint extends React.Component {
//
//     state = {
//         order: this.props.order,
//         openPanel: this.props.openPanel,
//         selectedOrderDetail: this.props.selectedOrderDetail
//     };
//
//
//
//     render() {
//         const { classes, user } = this.props;
//         const { order, openPanel, selectedOrderDetail } = this.state;
//
//         var totalAmount  = 0
//         {
//             order && order.length > 0 &&
//             order.slice(0, order.length).map((data, index) => {
//                 let obj = this.state.order[index].answers;
//
//                 Object.keys(obj).map(function (key) {
//                     if (obj[key].name === "total") {
//                         var SampleText =obj[key].answer.toString();
//                         var NewText = SampleText.replace("$", "");
//                         totalAmount = totalAmount + Number(NewText)
//                         totalAmount =   +totalAmount.toFixed(2);
//                     }
//                 })
//             })
//         }
//
//         return(
//             <div id={this.props.printableId} className='kitchenPrintme' style={{ display: "none" }}>
//                 {order && order.length > 0 && selectedOrderDetail && order.slice(0, 1).map((order, index,key) => {
//                     let obj = selectedOrderDetail.answers;
//
//                     let isactiveOrCompleted = ""
//
//                     let orderType = ""
//
//                     let created_date = moment.utc(selectedOrderDetail.created_at).format('ddd, MMM Do');
//                     let created_time = moment.utc(selectedOrderDetail.created_at).format('h:mm A');
//
//                     let customer = ""
//                     let deliveryAddress = ""
//                     let deliveryAddress2 = ""
//                     let address2 = ""
//                     let state = ""
//                     let city = ""
//                     let postal = ""
//                     let phonenumber = ""
//                     let email = ""
//
//                     let foodInstructions = ""
//
//                     let orderDetails = []
//
//                     let subTotal = ""
//                     let tax = ""
//                     let tip = ""
//                     let total = "-"
//
//                     let prepare_by_date = ""
//                     let prepare_by_time = "-"
//
//                     Object.keys(obj).map(function (key) {
//                         if (obj[key].name === "name") {
//                             customer = obj[key].prettyFormat;
//                         }
//                         else if (obj[key].name === "deliveryAddress") {
//                             if (obj[key].answer !== undefined && obj[key].answer !== "") {
//                                 if (obj[key].answer["addr_line1"] !== "" && obj[key].answer["addr_line1"] !== undefined) {
//                                     deliveryAddress = obj[key].answer["addr_line1"]
//                                 }
//                                 deliveryAddress2 = obj[key].answer["addr_line2"]
//                                 state = obj[key].answer["state"]
//                                 city = obj[key].answer["city"]
//                                 postal = obj[key].answer["postal"]
//                                 if (deliveryAddress2 !== "") {
//                                     address2 = deliveryAddress2
//                                 }
//                                 if (city !== "") {
//                                     address2 = address2 !== "" ? address2 + ', ' + city : city
//                                 }
//                                 if (state !== "") {
//                                     address2 = address2 !== "" ? address2 + ', ' + state : state
//                                 }
//                                 if (postal !== "") {
//                                     address2 = address2 !== "" ? address2 + ' ' + postal : postal
//                                 }
//                             }
//                         }
//                         else if (obj[key].name === "prepareBy") {
//                             let strDateTime  = obj[key].answer ? obj[key].answer : ""
//                             if (strDateTime !== "") {
//                                 var valid = moment(strDateTime).isValid()
//                                 if (valid) {
//                                     prepare_by_date = moment.utc(strDateTime).format('ddd, MMM Do');
//                                     prepare_by_time = moment.utc(strDateTime).format('h:mm A');
//                                 } else {
//                                     prepare_by_date = moment.unix(strDateTime).format('ddd, MMM Do');
//                                     prepare_by_time = moment.unix(strDateTime).format('h:mm A');
//                                 }
//                             }
//                         }
//                         else if (obj[key].name === "phoneNumber") {
//                             phonenumber = obj[key].prettyFormat
//                         }
//                         else if (obj[key].name === "email") {
//                             email = obj[key].answer
//                         }
//                         else if (obj[key].name === "foodInstructions") {
//                             foodInstructions = obj[key].answer
//                         }
//                         else if (obj[key].name === "orderDetails") {
//                             let obj1 = obj[key].answer
//                             orderDetails.push({
//                                 obj1
//                             })
//                             // orderDetails = obj[key].answer
//                         }
//                         else if (obj[key].name === "pickupdelivery") {
//                             orderType = obj[key].answer
//                         }
//                         else if (obj[key].name === "total") {
//                             total = obj[key].answer
//                         }
//                         else if (obj[key].name === "isactiveorcompleted") {
//                             isactiveOrCompleted = obj[key].answer;
//                         }
//                     })
//
//                     return (
//                         <div style={{width:"350px", alignContent:"center", margin:"auto"}}>
//                             <div>
//                                 <div style={{marginTop:'10px', width:'100%'}}>
//                                     <div style={{textAlign:"center"}}>
//                                         <label style={{fontSize:'30px',fontWeight:'bold', height:'60px'}}>{orderType}</label>
//                                     </div>
//                                     <div  style={{marginTop: '20px'}}>
//                                         <div>
//                                             <label style={{fontSize:'0.5em!important',fontWeight:'bold', height:'20px'}}> {customer} </label>
//                                         </div>
//                                         {phonenumber !== "" && phonenumber !== undefined ?
//                                             <div>
//                                                 <label style={{fontSize: '16px', fontWeight:'normal', height: '20px'}}>{phonenumber}</label>
//                                             </div>
//                                             : ""
//                                         }
//                                     </div>
//                                     <div style={{marginTop: '20px'}}>
//                                         <label style={{fontSize: '16px', height: '20px', fontWeight:'bold'}}>{orderType === "Delivery" ? 'Deliver by: ' : 'Pick Up at: '}</label>
//                                         <label style={{fontSize: '16px', fontWeight: 'normal', height: '20px'}}>{prepare_by_date} - {prepare_by_time} </label>
//                                     </div>
//                                 </div>
//                                 {foodInstructions !== "" && foodInstructions !== undefined ?
//                                     <div style={{marginTop: '20px'}}>
//                                         <div>
//                                             <label style={{fontSize:'0.5em!important', fontWeight:'bold', height: '20px', color:'red'}}> Food Instructions: </label>
//                                         </div>
//                                         <div>
//                                             <label style={{fontSize: '16px', fontWeight:'normal', height: '20px'}} dangerouslySetInnerHTML={{__html: foodInstructions}}></label>
//                                         </div>
//                                     </div> : ""
//                                 }
//                                 {orderDetails.map((orderDetailsObj, index) => {
//                                     let obj2 = orderDetails[index]["obj1"];
//
//                                     let arrPayment = JSON.parse(obj2["paymentArray"])
//
//                                     if (arrPayment !== "" && arrPayment !== undefined){
//                                         if (arrPayment.subtotal !== undefined) {
//                                             subTotal = (Math.round(arrPayment.subtotal * 100) / 100).toFixed(2)
//                                         }
//                                         if (arrPayment.tax !== undefined) {
//                                             tax = (Math.round(arrPayment.tax * 100) / 100).toFixed(2)
//                                         }
//                                     }
//
//                                     return (
//                                         <div style={{marginTop: '20px'}}>
//                                             <Table style={{border:'none', width:'100%'}}>
//                                                 <TableBody>
//                                                     {Object.keys(obj2).map(function (key) {
//                                                         let data = JSON.parse(obj2[key])
//
//                                                         if (data.name === "Tip" && data.options !== undefined && data.options !== "") {
//                                                             var SampleText =data.options[0].selected.toString();
//                                                             var NewText = SampleText.replace("$", "");
//                                                             tip = (Math.round(NewText * 100) / 100).toFixed(2)
//                                                         }
//
//                                                         if (data !== "" && data !== undefined && data.name !== "" && data.name !== undefined && data.name !== "Tip") {
//                                                             return (
//                                                                 <TableRow style ={{height:45, fontSize:'15px', marginTop:'15px' }}>
//                                                                     <TableCell style={{fontSize:'1.0em!important', width:'10%', fontWeight:'bold',verticalAlign: 'top' }}>
//                                                                         {data.quantity}
//                                                                     </TableCell>
//                                                                     <TableCell style={{ fontSize:'1.0em!important', verticalAlign: 'top', width:'35%', fontWeight:'bold'}}>
//                                                                         <div>
//                                                                             {data.name}
//                                                                             {Object.keys(data.options).map(function (key) {
//                                                                                 let dataOptions = data.options[key] //JSON.parse()
//
//                                                                                 if (dataOptions.name !== "Quantity") {
//                                                                                     return (<div style={{marginLeft:'5px', fontWeight:'lighter'}}>
//                                                                                         {dataOptions.selected}
//                                                                                     </div>)
//                                                                                 }
//                                                                             })
//                                                                             }
//                                                                         </div>
//                                                                     </TableCell>
//                                                                 </TableRow>
//                                                             )
//                                                         }
//                                                     })
//                                                     }
//                                                 </TableBody>
//                                             </Table>
//                                         </div>
//                                     )
//                                 })
//                                 }
//                             </div>
//                         </div>
//                     )
//                 })
//                 }
//             </div>
//         )
//     }
// }

class OrdersTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDropDownvalue: 'All',
            deletedOrderId: undefined,
            deleteConfirmationVisible: false,
            markAsCompleteConfirmationVisible: false,
            markAsCancelConfirmationVisible: false,
            refundConfirmationVisible: false,
            isCustomerToPrint: false,
            datePickerIsOpen: false,
            onlineOrderMessageValue: "",
            showError:false,
            showNewOrderReceivedWindow: false,
            page: 0,
            rowsPerPage: 40,
        }

        this.timer = null;

        this.callDeleteOrderApi = this.callDeleteOrderApi.bind(this);
        this.callMarkAsCompleteOrderApi = this.callMarkAsCompleteOrderApi.bind(this);
        this.callMarkAsCancelOrderApi = this.callMarkAsCancelOrderApi.bind(this);
        this.callSendMessageApi = this.callSendMessageApi.bind(this);
        this.callUpdateOrder = this.callUpdateOrder.bind(this);
        this.callRefundApi = this.callRefundApi.bind(this);

        this.formatPhoneNumber = this.formatPhoneNumber.bind(this);

        this.showMessagePopup = this.showMessagePopup.bind(this);
        this.hideMessagePopup = this.hideMessagePopup.bind(this);
        this.toggleDeleteConfirmationVisible = this.toggleDeleteConfirmationVisible.bind(this);
        this.toggleMarkAsCompleteConfirmationVisible = this.toggleMarkAsCompleteConfirmationVisible.bind(this);
        this.toggleMarkAsCancelConfirmationVisible = this.toggleMarkAsCancelConfirmationVisible.bind(this);
        this.toggleRefundConfirmationVisible = this.toggleRefundConfirmationVisible.bind(this);

        this.handleChangeDropDown = this.handleChangeDropDown.bind(this);
        this.handleOnlineOrderMessageChange = this.handleOnlineOrderMessageChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.openDatePicker = this.openDatePicker.bind(this)
    }

    setOnlineOrderMessage = () => {
        if (this.props.user.BusinessUser.OnlineOrderMessage !== undefined && this.props.user.BusinessUser.OnlineOrderMessage !== "") {
            this.setState({ onlineOrderMessageValue: this.props.user.BusinessUser.OnlineOrderMessage }, () => {
                // console.log(this.state.onlineOrderMessageValue, 'onlineOrderMessageValue');
            });
        }
    }

    componentDidMount() {

        audioFunc(true,false,'')

        this.setOnlineOrderMessage()

        if (this.props.user.BusinessUser.OnlineOrderFormType !== "jotform") {
            this.setState({
                isFirstTime: true
            })
        }

        this.callGetOrder(this.state.selectedDropDownvalue)
    }

    componentWillReceiveProps(nextProps) { //this is called to before render method

        if (localStorage.getItem('newOrderCount') !== undefined && localStorage.getItem('newOrderCount') !== '' && localStorage.getItem('newOrderCount') !== null && Number(localStorage.getItem('newOrderCount')) > 0) {
            this.setState({
                showNewOrderReceivedWindow : true
            })
        }

        if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
            let isActiveOrCompletedId = 0
            let prepareById = 0

            //To Apply Filter
            if (nextProps.order) {
                nextProps.order && nextProps.order.length > 0 && nextProps.order.slice(0, 1).map((order, index) => {
                    let obj = nextProps.order[index].answers;
                    Object.keys(obj).map(function (key) {
                        let value = obj[key];

                        if ((value.type !== "control_button") && (value.type !== "control_head") && (value.type !== "control_image")) {
                            if (value.name === "isactiveorcompleted") {
                                isActiveOrCompletedId = key
                            } else if (value.name === "prepareBy") {
                                prepareById = key
                            }
                        }
                    })
                })

                if (isActiveOrCompletedId !== 0) {
                    this.setState({
                        isActiveOrCompletedId: isActiveOrCompletedId
                    })
                }

                if (this.state.prepareById !== 0) {
                    this.setState({
                        prepareById: prepareById
                    })
                }
            }
            this.setState({
                order: nextProps.order,
                originalOrder: nextProps.order,
                newDataReceived: true,
            })
        } else {
            if (!isEqual(nextProps.order, this.props.order)) {
                this.setState({
                    order: nextProps.order
                })
            } else if ((this.state.isFirstTime === true) || (this.state.selectedDropDownvalue === nextProps.orderReducer.dropDownValue)) {
                this.setState({
                    order: nextProps.order,
                    isFirstTime: false
                })
            }
        }
    }

    componentDidUpdate(nextProps, prevState) {

        if (localStorage.getItem('UserId') !== null) {
            if (this.props.user.BusinessUser.OnlineOrderFormType !== "jotform" && this.state.page === 0) {
                if (!isEqual(nextProps.order, this.props.order)) {
                    clearInterval(this.timer);
                    this.timer = setInterval(() => {
                            this.callGetOrder(this.state.selectedDropDownvalue)
                        }, 60000
                    );
                } else if (this.timer === null) {
                    this.timer = setInterval(() => {
                            this.callGetOrder(this.state.selectedDropDownvalue)
                        }, 60000
                    );
                }
            } else if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
                if (!isEqual(nextProps.order, this.props.order)) {
                    clearInterval(this.timer);
                    this.timer = setInterval(() => {
                            this.callGetOrder(this.state.selectedDropDownvalue)
                        }, 60000
                    );
                } else if (this.timer === null) {
                    this.timer = setInterval(() => {
                            this.callGetOrder(this.state.selectedDropDownvalue)
                        }, 60000
                    );
                }
            }
        } else {
            clearInterval(this.timer);

            const {userData} = this.props;
            if (userData !== undefined) {
                userData.remove('user')
            }
        }
    }

    componentWillMount() {
        localStorage.setItem('orderCount', '');
    }

    componentWillUnmount() {
        clearInterval(this.timer);

        if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
            if (this.props.order && this.props.order.length > 0) {
                localStorage.setItem('orderCount', this.props.order.length);
            }
        } else if (this.props.orderReducer.totalOrders > 0) {
            localStorage.setItem('orderCount', this.props.orderReducer.totalOrders);
        }
    }

    handleChangeDropDown = (value, event) => {

        if ((event !== undefined && event.target.value === "Active") || (value === "Active")) {
            if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
                this.state.order = this.state.originalOrder

                var filteredArr = []
                this.state.order.filter((orderObj) => {
                    {
                        Object.keys(orderObj.answers)
                            .filter(key => (orderObj.answers[key].answer === "Active" ||  orderObj.answers[key].answer === "processing")).map(function () {
                            filteredArr.push({
                                orderObj
                            })
                        })
                    }
                })

                if (filteredArr.length > 0) {
                    var filteredData = []

                    for (var i in filteredArr) {
                        filteredData.push(filteredArr[i].orderObj);
                    }

                    this.state.order = filteredData
                } else {
                    this.state.order = undefined
                }

                if (this.state && this.state.order) {

                    let orderCopy = this.state.order

                    orderCopy.slice(0, orderCopy.length).map((data, index) => {
                        let orderDetails = orderCopy[index].answers;

                        Object.keys(orderDetails).map(function (key) {

                            if (orderDetails[key].name === "prepareBy") {
                                orderCopy.sort((a, b) => new Date(a.answers[key].answer).getTime() - new Date(b.answers[key].answer).getTime())

                                // orderCopy.sort((a, b) => a.answers[key].answer.localeCompare(b.answers[key].answer))
                            }
                        })
                    })

                    if (orderCopy !== undefined && orderCopy !== "" && orderCopy !== null) {
                        this.setState({
                            order: orderCopy
                        })
                    }
                //this.state.order.sort((a, b) => b.created_at.localeCompare(a.created_at))
                }
        }
        } else if ((event !== undefined && event.target.value === "Completed") || value === "Completed") {
            if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
                this.state.order = this.state.originalOrder

                var filteredArr = []
                this.state.order.filter((orderObj) => {
                    {
                        Object.keys(orderObj.answers)
                            .filter(key => orderObj.answers[key].answer === "Completed").map(function () {

                            filteredArr.push({
                                orderObj
                            })
                        })
                    }
                })

                if (filteredArr.length > 0) {
                    var filteredData = []

                    for (var i in filteredArr) {
                        filteredData.push(filteredArr[i].orderObj);
                    }

                    this.state.order = filteredData
                } else {
                    this.state.order = undefined
                }

                if (this.state && this.state.order) {

                    let orderCopy = this.state.order

                    orderCopy.slice(0, orderCopy.length).map((data, index) => {
                        let orderDetails = orderCopy[index].answers;

                        Object.keys(orderDetails).map(function (key) {

                            if (orderDetails[key].name === "prepareBy") {

                                orderCopy.sort((a, b) => new Date(b.answers[key].answer).getTime() - new Date(a.answers[key].answer).getTime())
                                // orderCopy.sort((a, b) => (b.answers[key].answer).localeCompare(a.answers[key].answer))
                            }
                        })
                    })

                    if (orderCopy !== undefined && orderCopy !== "" && orderCopy !== null) {
                        this.setState({
                            order: orderCopy
                        })
                    }
                    this.state.order.sort((a, b) => b.created_at.localeCompare(a.created_at))
                }
            }
        } else if ((event !== undefined && event.target.value === "Cancelled") || value === "Cancelled") {
            if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
                this.state.order = this.state.originalOrder

                var filteredArr = []
                this.state.order.filter((orderObj) => {
                    {
                        Object.keys(orderObj.answers)
                            .filter(key => orderObj.answers[key].answer === "Cancelled").map(function () {

                            filteredArr.push({
                                orderObj
                            })
                        })
                    }
                })

                if (filteredArr.length > 0) {
                    var filteredData = []

                    for (var i in filteredArr) {
                        filteredData.push(filteredArr[i].orderObj);
                    }

                    this.state.order = filteredData
                } else {
                    this.state.order = undefined
                }

                if (this.state && this.state.order) {

                    let orderCopy = this.state.order

                    orderCopy.slice(0, orderCopy.length).map((data, index) => {
                        let orderDetails = orderCopy[index].answers;

                        Object.keys(orderDetails).map(function (key) {

                            if (orderDetails[key].name === "prepareBy") {
                                orderCopy.sort((a, b) => new Date(b.answers[key].answer).getTime() - new Date(a.answers[key].answer).getTime())
                                // orderCopy.sort((a, b) => (b.answers[key].answer).localeCompare(a.answers[key].answer))
                            }
                        })
                    })

                    if (orderCopy !== undefined && orderCopy !== "" && orderCopy !== null) {
                        this.setState({
                            order: orderCopy
                        })
                    }
                    //this.state.order.sort((a, b) => b.created_at.localeCompare(a.created_at))
                }
            }
        } else if ((event !== undefined && event.target.value === "All") || value === "All") {
            if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
                this.state.order = this.state.originalOrder

                this.state.order.sort((a, b) => b.created_at.localeCompare(a.created_at))
            }
        }

        if (event !== undefined) {
            this.setState({
                selectedDropDownvalue: event.target.value,
                page: 0,
                order: undefined,
                // exportOrders: undefined,
            }, () => {
                this.props.parentCallback(this.state.selectedDropDownvalue, this.state.isActiveOrCompletedId);

                if (this.props.user.BusinessUser.OnlineOrderFormType !== "jotform") {
                    this.callGetOrder(this.state.selectedDropDownvalue)
                }
                // clearInterval(this.getExportOrdersTimer)
                //
                // this.callGetOrderByDateRange(moment(this.state.startDate).format('MM/DD/YYYY'),moment(this.state.endDate).add(1, 'days').format('MM/DD/YYYY'),this.state.selectedDropDownvalue)
            });
        }
    };

    showRightSideView = (id) => {

        let obj = this.state.order[id];

        this.setState({
            openPanel: true,
            selectedOrderDetail: obj
        });
    }

    hideRightSideView = (id, event) => {
        if (((event !== undefined && event !== "" && event.target.className === 'glass') || (id !== "" && id === "closeButton")) && this.state.openPanel) {
            this.hideRightSideViewWithoutClick()
            //event.target.className.baseVal === 'MuiSvgIcon-root MuiSvgIcon-fontSizeLarge'
        }
    };

    hideRightSideViewWithoutClick = () => {
        this.setState({
            openPanel: false,
        });
    }

    showMessagePopup() {
        let message = ""
        if (this.state.onlineOrderMessageValue === undefined || this.state.onlineOrderMessageValue === "" || this.state.onlineOrderMessageValue === null) {
            message = "Your order is ready for pickup at" + " " + this.props.user.AppUser.FirstName
        } else if (this.state.onlineOrderMessageValue.includes("Your order is ready for pickup at")) {
            var checkmsg  = this.state.onlineOrderMessageValue.split("Your order is ready for pickup at");

            if (Array.isArray(checkmsg)) {
                checkmsg.splice(0, 1);
                if (checkmsg.length > 0) {
                    if (checkmsg[0] !== "") {
                        checkmsg = checkmsg[0].split(this.props.user.AppUser.FirstName.trim());
                    }
                    checkmsg.splice(0, 1);
                    if (checkmsg.length > 0) {
                        if (checkmsg[0].trim() !== "") {
                            message = this.state.onlineOrderMessageValue
                        } else {
                            // var msg = this.state.onlineOrderMessageValue.split(this.props.user.AppUser.FirstName.trim());
                            // message = msg[0].trim()
                            if(!this.state.onlineOrderMessageValue.includes(this.props.user.AppUser.FirstName)) {
                                message = this.state.onlineOrderMessageValue + " " + this.props.user.AppUser.FirstName.trim()
                            }
                        }
                    } else {
                        var msg = this.state.onlineOrderMessageValue.split(this.props.user.AppUser.FirstName.trim());
                        message = msg[0].trim()
                        if(!this.state.onlineOrderMessageValue.includes(this.props.user.AppUser.FirstName) && this.state.onlineOrderMessageValue === "Your order is ready for pickup at") {
                            message = this.state.onlineOrderMessageValue + " " + this.props.user.AppUser.FirstName.trim()
                        } else {
                            message = this.state.onlineOrderMessageValue
                        }
                    }
                } else {
                    message = this.state.onlineOrderMessageValue
                }
            } else {
                message = this.state.onlineOrderMessageValue
            }
        }   else {
            message = this.state.onlineOrderMessageValue
        }
        this.setState({
            onlineOrderMessageValue : message,
            showMessagePopup: true,
        });
    }

    hideMessagePopup() {
        // let message = ""
        // if (this.state.onlineOrderMessageValue.includes("Your order is ready for pickup at")) {
        //     var checkmsg  = this.state.onlineOrderMessageValue.split("Your order is ready for pickup at");
        //
        //     if (Array.isArray(checkmsg)) {
        //         checkmsg.splice(0, 1);
        //         if (checkmsg.length > 0) {
        //             if (checkmsg[0] !== "") {
        //                 checkmsg = checkmsg[0].split(this.props.user.AppUser.FirstName.trim());
        //             }
        //             checkmsg.splice(0, 1);
        //             if (checkmsg.length > 0) {
        //                 if (checkmsg[0].trim() !== "") {
        //                     message = this.state.onlineOrderMessageValue
        //                 } else {
        //                    // var msg = this.state.onlineOrderMessageValue.split(this.props.user.AppUser.FirstName.trim());
        //                     if(!this.state.onlineOrderMessageValue.includes(this.props.user.AppUser.FirstName)) {
        //                         message = this.state.onlineOrderMessageValue + " " + this.props.user.AppUser.FirstName.trim()
        //                     }
        //                 }
        //             } else {
        //                 // var msg = this.state.onlineOrderMessageValue.split(this.props.user.AppUser.FirstName.trim());
        //                 // message = msg[0].trim()
        //                 if(!this.state.onlineOrderMessageValue.includes(this.props.user.AppUser.FirstName)) {
        //                     message = this.state.onlineOrderMessageValue + " " + this.props.user.AppUser.FirstName.trim()
        //                 }
        //             }
        //         } else {
        //             message = this.state.onlineOrderMessageValue
        //         }
        //     } else {
        //         message = this.state.onlineOrderMessageValue
        //     }
        // }   else {
        //     message = this.state.onlineOrderMessageValue
        // }

        this.setState({
            showMessagePopup: false,
            onlineOrderMessageValue : this.props.user.BusinessUser.OnlineOrderMessage
        });
    }

    setDeletedOrderId(id) {
        this.setState({deletedOrderId: id});
    }

    toggleDeleteConfirmationVisible() {
        const {deleteConfirmationVisible} = this.state;
        this.setState({deleteConfirmationVisible: !deleteConfirmationVisible});
    }

    toggleMarkAsCompleteConfirmationVisible() {
        const {markAsCompleteConfirmationVisible} = this.state;
        this.setState({markAsCompleteConfirmationVisible: !markAsCompleteConfirmationVisible});
    }

    toggleMarkAsCancelConfirmationVisible() {
        const {markAsCancelConfirmationVisible} = this.state;
        this.setState({markAsCancelConfirmationVisible: !markAsCancelConfirmationVisible});
    }

    toggleRefundConfirmationVisible() {
        const {refundConfirmationVisible} = this.state;
        this.setState({
            refundConfirmationVisible: !refundConfirmationVisible,
            maximumRefundValue: '',
            refundValue: ''
        });
    }

    toggleDatePickerVisible() {
        this.datePicker._showDatePickerPopup()
    }

    handleOnlineOrderMessageChange = (event) => {
        this.setState({onlineOrderMessageValue: event.target.value});
    }

    callSaveMessageAPI() {
        if (this.props.user.BusinessUser.BusinessId !== undefined && this.props.user.BusinessUser.BusinessId !== "") {
            let message = ""
            if (this.state.onlineOrderMessageValue !== undefined && this.state.onlineOrderMessageValue !== '') {
                if (this.state.onlineOrderMessageValue.includes("Your order is ready for pickup at")) {
                    var checkmsg  = this.state.onlineOrderMessageValue.split("Your order is ready for pickup at");

                    if (Array.isArray(checkmsg)) {
                        checkmsg.splice(0, 1);
                        if (checkmsg.length > 0) {
                            if (checkmsg[0] !== "") {
                                checkmsg = checkmsg[0].split(this.props.user.AppUser.FirstName.trim());
                            }
                            checkmsg.splice(0, 1);
                            if (checkmsg.length > 0) {
                                if (checkmsg[0].trim() !== "") {
                                    message = this.state.onlineOrderMessageValue
                                } else {
                                    // var msg = this.state.onlineOrderMessageValue.split(this.props.user.AppUser.FirstName.trim());
                                    // message = msg[0].trim()
                                    if(!this.state.onlineOrderMessageValue.includes(this.props.user.AppUser.FirstName)) {
                                        message = this.state.onlineOrderMessageValue + " " + this.props.user.AppUser.FirstName.trim()
                                    }
                                }
                            } else {
                                var msg = this.state.onlineOrderMessageValue.split(this.props.user.AppUser.FirstName.trim());
                                message = msg[0].trim()
                                if(!this.state.onlineOrderMessageValue.includes(this.props.user.AppUser.FirstName) && this.state.onlineOrderMessageValue === "Your order is ready for pickup at") {
                                    message = this.state.onlineOrderMessageValue + " " + this.props.user.AppUser.FirstName.trim()
                                } else {
                                    message = this.state.onlineOrderMessageValue
                                }
                            }
                        } else {
                            message = this.state.onlineOrderMessageValue
                        }
                    } else {
                        message = this.state.onlineOrderMessageValue
                    }
                }  else {
                    message = this.state.onlineOrderMessageValue
                }
            } else {
                if (this.state.onlineOrderMessageValue === undefined || this.state.onlineOrderMessageValue === "") {
                    message = "Your order is ready for pickup at"
                }
            }

            this.props.saveOnlineOrderMessage(this.props.user.BusinessUser.BusinessId, message).then((data) => {
                if (data.results.ResponseCode === true) {
                    this.setState({
                        // showAlert: !this.state.showAlert,
                        showSuccess: true,
                        showError: false,
                        msg: 'Your message has been saved successfully.',
                        onlineOrderMessageValue : message,
                    });
                    this.props.user.BusinessUser.OnlineOrderMessage = message;
                    this.hideMessagePopup()
                } else {

                }
            });
        }
    }

    callDeleteOrderApi() {

        this.setDeletedOrderId(this.state.selectedOrderDetail.id);
        this.toggleDeleteConfirmationVisible();

        this.setState((state) => {
            const {order, deletedOrderId} = state;
            const nextData = order.filter(order => order.id !== deletedOrderId);

            this.props.deleteOrder(`https://api.jotform.com/submission/${deletedOrderId}?apiKey=09ec9741da1cb60e6cf174b550577672`).then(() => {
                this.setState({
                    // showAlert: !this.state.showAlert,
                    showSuccess: true,
                    showError: false,
                    msg: 'Your order has been deleted.',
                    order: nextData,
                    deletedOrderId: null
                });
            });
        });

        this.hideRightSideViewWithoutClick();
        this.toggleDeleteConfirmationVisible();
    }

    callMarkAsCompleteOrderApi() {

        this.toggleMarkAsCompleteConfirmationVisible();

        let obj = this.state.selectedOrderDetail.answers

        var activeorcompleteId = ''
        Object.keys(obj).map(function (key) {
            if (obj[key].name === "isactiveorcompleted") {
                activeorcompleteId = key
            }
        })

        var dict = {};

        dict[activeorcompleteId] = "Completed"

        const {order} = this.state;
        if (this.state.selectedDropDownvalue === "Active") {

            const nextData = order.filter(order => order.id !== this.state.selectedOrderDetail.id);

            return this.callUpdateOrder(
                'updateStatus',
                this.state.selectedOrderDetail.id,
                dict,
                'Your order has been marked as complete.',
                nextData,
                ''
            ).then(() => {
                this.callGetOrder(this.state.selectedDropDownvalue)
                this.hideRightSideViewWithoutClick();
            });
        } else {
            return this.callUpdateOrder(
                'updateStatus',
                this.state.selectedOrderDetail.id,
                dict,
                'Your order has been marked as complete.',
                order,
                ''
            ).then(() => {
                this.callGetOrder(this.state.selectedDropDownvalue)
                this.hideRightSideViewWithoutClick();
            });
        }
    };

    callMarkAsCancelOrderApi() {

        this.toggleMarkAsCancelConfirmationVisible();

        let obj = this.state.selectedOrderDetail.answers

        var activeorcompleteId = ''
        Object.keys(obj).map(function (key) {
            if (obj[key].name === "isactiveorcompleted") {
                activeorcompleteId = key
            }
        })

        var dict = {};

        dict[activeorcompleteId] = "Cancelled"

        const {order} = this.state;
        if (this.state.selectedDropDownvalue === "Active") {
            const nextData = order.filter(order => order.id !== this.state.selectedOrderDetail.id);

            return this.callUpdateOrder(
                'updateStatus',
                this.state.selectedOrderDetail.id,
                dict,
                'Your order has been cancelled.',
                nextData,
                ''
            ).then(() => {
                this.callGetOrder(this.state.selectedDropDownvalue)

                const { user } = this.props;
                var profileImageURL = '';
                if(user.AppUser.ProfileImage && user.AppUser.ProfileImage) {
                    profileImageURL = `https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${this.props.user.AppUser.ProfileImage}`;
                }

                let customer = ""
                let email = ""
                if (this.state.selectedOrderDetail !== "") {
                    let obj = this.state.selectedOrderDetail.answers;

                    Object.keys(obj).map(function (key) {
                        if (obj[key].name === "name") {
                            customer = obj[key].prettyFormat;
                        }
                        else if (obj[key].name === "email") {
                            email = obj[key].answer
                        }
                    })
                }

                this.props.sendMail(user.AppUser.Email,email,'OrderCancel',profileImageURL,user.AppUser.FirstName,this.onTextChange(user.AppUser.PhoneNo),customer,'','').then((data) => {
                    if (data.results.ResponseCode === true) {

                    } else {

                    }
                });

                this.hideRightSideViewWithoutClick();
            });
        } else {
            return this.callUpdateOrder(
                'updateStatus',
                this.state.selectedOrderDetail.id,
                dict,
                'Your order has been cancelled.',
                order,
                ''
            ).then(() => {

                this.callGetOrder(this.state.selectedDropDownvalue)

                const { user } = this.props;
                var profileImageURL = '';
                if(user.AppUser.ProfileImage && user.AppUser.ProfileImage) {
                    profileImageURL = `https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${this.props.user.AppUser.ProfileImage}`;
                }

                let customer = ""
                let email = ""
                if (this.state.selectedOrderDetail !== "") {
                    let obj = this.state.selectedOrderDetail.answers;

                    Object.keys(obj).map(function (key) {
                        if (obj[key].name === "name") {
                            customer = obj[key].prettyFormat;
                        }
                        else if (obj[key].name === "email") {
                            email = obj[key].answer
                        }
                    })
                }

                this.props.sendMail(user.AppUser.Email,email,'OrderCancel',profileImageURL,user.AppUser.FirstName,this.onTextChange(user.AppUser.PhoneNo),customer,'','').then((data) => {
                    if (data.results.ResponseCode === true) {

                    } else {

                    }
                });

                this.hideRightSideViewWithoutClick();
            });
        }
    };

    callRefundApi() {

        this.toggleRefundConfirmationVisible();

        let obj = this.state.selectedOrderDetail.answers

        const {order} = this.state;
        if (this.state.selectedDropDownvalue === "Active") {

            const nextData = order.filter(order => order.id !== this.state.selectedOrderDetail.id);

            this.props.stripeRefund(
                this.state.selectedOrderDetail.woocommerce_order_id,
                this.state.selectedOrderDetail.trans_id,
                this.state.refundValue
            ).then((data) => {
                this.setState({
                    showSuccess: true,
                    showError: false,
                    msg: 'Your amount will be refund.',
                    order: nextData
                });
                this.callGetOrder(this.state.selectedDropDownvalue)
            });
        } else {
            this.props.stripeRefund(
                this.state.selectedOrderDetail.woocommerce_order_id,
                this.state.selectedOrderDetail.trans_id,
                this.state.refundValue
            ).then((data) => {
                this.setState({
                    showSuccess: true,
                    showError: false,
                    msg: 'Your amount will be refund.',
                    order: order
                });
                this.callGetOrder(this.state.selectedDropDownvalue)
            });
        }
    };

    callSendMessageApi = (id) => {

        var idToUpdate = ''
        var obj = ''
        if (id !== undefined && id !== "") {
            idToUpdate = this.state.order[id].id;
            obj = this.state.order[id].answers;
        } else {
            idToUpdate = this.state.selectedOrderDetail.id;
            obj = this.state.selectedOrderDetail.answers;
        }

        var notifieduserId = ''
        var phoneNumber = ''
        var orderType = ''

        Object.keys(obj).map(function (key) {
            if (obj[key].name === "isnotifieduser") {
                notifieduserId = key
            } else if (obj[key].name === "phoneNumber") {
                phoneNumber = obj[key].prettyFormat
            } else if (obj[key].name === "pickupdelivery") {
                orderType = obj[key].answer.toLowerCase()
                    .split(' ')
                    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                    .join(' ');
                orderType = (orderType === "Doordash_delivery" ? 'DoorDash Delivery' : orderType);
            }
        })

        if (phoneNumber !== undefined && phoneNumber !== '' && orderType !== "Delivery" && orderType !== "DoorDash Delivery") {
            let message = ""
            if (this.state.onlineOrderMessageValue === undefined || this.state.onlineOrderMessageValue === "" || this.state.onlineOrderMessageValue === null) {
                message = "Your order is ready for pickup at" + " " + this.props.user.AppUser.FirstName.trim()
            } else if (this.state.onlineOrderMessageValue.includes("Your order is ready for pickup at")) {
                var checkmsg  = this.state.onlineOrderMessageValue.split("Your order is ready for pickup at");

                if (Array.isArray(checkmsg)) {
                    checkmsg.splice(0, 1);
                    if (checkmsg.length > 0) {
                        if (checkmsg[0] !== "") {
                            checkmsg = checkmsg[0].split(this.props.user.AppUser.FirstName.trim());
                        }
                        checkmsg.splice(0, 1);
                        if (checkmsg.length > 0) {
                            if (checkmsg[0].trim() !== "") {
                                message = this.state.onlineOrderMessageValue
                            } else {
                                // var msg = this.state.onlineOrderMessageValue.split(this.props.user.AppUser.FirstName.trim());
                                // message = msg[0].trim()
                                if(!this.state.onlineOrderMessageValue.includes(this.props.user.AppUser.FirstName)) {
                                    message = this.state.onlineOrderMessageValue + " " + this.props.user.AppUser.FirstName.trim()
                                }
                            }
                        } else {
                            var msg = this.state.onlineOrderMessageValue.split(this.props.user.AppUser.FirstName.trim());
                            message = msg[0].trim()
                            if(!this.state.onlineOrderMessageValue.includes(this.props.user.AppUser.FirstName) && this.state.onlineOrderMessageValue === "Your order is ready for pickup at") {
                                message = this.state.onlineOrderMessageValue + " " + this.props.user.AppUser.FirstName.trim()
                            } else {
                                message = this.state.onlineOrderMessageValue
                            }
                        }
                    } else {
                        message = this.state.onlineOrderMessageValue
                    }
                } else {
                    message = this.state.onlineOrderMessageValue
                }
            }   else {
                message = this.state.onlineOrderMessageValue
            }

            this.props.sendMessage(phoneNumber, message).then((data) => {
                if (data.results.ResponseCode === true) {
                    this.setState({
                        // showAlert: !this.state.showAlert,
                        showSuccess: true,
                        showError: false,
                        msg: 'You have sent a message to let customer know order is ready for pickup.',
                    });

                    var dict = {};

                    dict[notifieduserId] = "Yes"

                    const {order} = this.state;
                    if (this.state.selectedDropDownvalue === "Active") {

                        const nextData = order.filter(order => order.id !== idToUpdate);

                        return this.callUpdateOrder(
                            'updateIsNotified',
                            idToUpdate,
                            dict,
                            null,
                            nextData,
                            ''
                        ).then(() => {
                            this.callGetOrder(this.state.selectedDropDownvalue);
                        });
                    } else {
                        return this.callUpdateOrder(
                            'updateIsNotified',
                            idToUpdate,
                            dict,
                            null,
                            order,
                            ''
                        ).then(() => {
                            this.callGetOrder(this.state.selectedDropDownvalue);
                        });
                    }
                } else {
                    this.setState({
                        // showAlert: !this.state.showAlert,
                        showSuccess: false,
                        showError:true,
                        msg: 'Phone number is not valid.',
                    });
                }
            });
        }

        if (id === '') {
            this.hideRightSideViewWithoutClick();
        }
    }

    callGetOrder(selectedDropDownvalue) {
        if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
            // let strStartDate =  moment().subtract(29,'days').format('MM/DD/YYYY')
            // let strEndDate = moment().add(1, 'days').format('MM/DD/YYYY')
            let strStartDate =  moment().subtract(6,'days').format('MM/DD/YYYY')
            let strEndDate = moment().add(1, 'days').format('MM/DD/YYYY')

            if (selectedDropDownvalue === "All") {
                this.props.getOrder(this.props.user.BusinessUser.OnlineOrderFormType,`https://api.jotform.com/form/${this.props.user.BusinessUser.OnlineOrderFormId}/submissions?apiKey=09ec9741da1cb60e6cf174b550577672&limit=1000&filter={"created_at:gt":"${strStartDate}","created_at:lt":"${strEndDate}"}`);
            } else if (this.state.isActiveOrCompletedId !== 0) {
                this.props.getOrder(this.props.user.BusinessUser.OnlineOrderFormType,`https://api.jotform.com/form/${this.props.user.BusinessUser.OnlineOrderFormId}/submissions?apiKey=09ec9741da1cb60e6cf174b550577672&limit=1000&filter={"created_at:gt":"${strStartDate}","created_at:lt":"${strEndDate}","q${this.state.isActiveOrCompletedId}:matches":"${selectedDropDownvalue}"}`);
            }
        } else {
            // let startDat =  moment().subtract(30,'days').format('MM-DD-YYYY HH:mm:ss')
            // let endDat =  moment().add(1, 'days').format('MM-DD-YYYY HH:mm:ss')
            let startDat =  moment().subtract(7,'days').format('MM-DD-YYYY HH:mm:ss')
            let endDat =  moment().add(1, 'days').format('MM-DD-YYYY HH:mm:ss')
            let utcStartDat = moment(startDat, "MM-DD-YYYY HH:mm:ss").utc().format('MM-DD-YYYY')
            let utcEndDat = moment(endDat, "MM-DD-YYYY HH:mm:ss").utc().format('MM-DD-YYYY')
            let type = (selectedDropDownvalue !== undefined && selectedDropDownvalue !== '') ? (selectedDropDownvalue === "Active") ? "processing" : selectedDropDownvalue : 'All'
            this.props.getOrder(this.props.user.BusinessUser.OnlineOrderFormType,`GrabWordpressOrdersWithPagination/${this.props.user.BusinessUser.OnlineOrderFormId}/${type}/${((this.state.page * this.state.rowsPerPage)+1)}/${this.state.rowsPerPage}/${utcStartDat}/${utcEndDat}`);
        }
    }

    callUpdateOrder(type, orderId, dict, msg, order, extraParam) {
        return this.props.updateOrder(
            type,
            this.props.user.BusinessUser.OnlineOrderFormType === "jotform" ? `https://api.jotform.com/submission/${orderId}?apiKey=09ec9741da1cb60e6cf174b550577672` : '/UpdateOrder',
            dict,
            this.props.user.BusinessUser.OnlineOrderFormType,
            orderId,
            extraParam).then((data) => {
            this.setState({
                showSuccess: true,
                showError: false,
                msg: msg,
                order: order
            });
        });
    }

    onTextChange(text) {
        var cleaned = ('' + text).replace(/\D/g, '')
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            var intlCode = (match[1] ? '+1 ' : ''),
                number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');

            return number;
        }

        this.setState({
            phoneNum: text
        });
    }

    deleteOrderClicked = () => {
        // console.log("Delete Order Clicked")

        this.setState({
            deleteConfirmationVisible: true,
        });
    };

    markAsCancelOrderClicked = (id) => {

        if (id !== undefined && id !== "") {

            let obj = this.state.order[id];

            this.setState({
                selectedOrder: obj
            });
        }

        // console.log("Mark as Cancel Clicked")

        this.setState({
            markAsCancelConfirmationVisible: true,
        });
    };

    markAsCompleteOrderClicked = (id) => {

        if (id !== undefined && id !== "") {

            let obj = this.state.order[id];

            this.setState({
                selectedOrder: obj
            });
        }

        // console.log("Mark as Complete Clicked")

        this.setState({
            markAsCompleteConfirmationVisible: true,
        });
    };

    refundClicked = (id) => {

        if (id !== undefined && id !== "") {

            let obj = this.state.order[id];

            this.setState({
                selectedOrder: obj
            });
        }

        let ans = this.state.order[id].answers;

        var total = ''
        Object.keys(ans).map(function (key) {
            if (ans[key].name === "total") {
                total = ans[key].answer
            }
        })

        // console.log("Refund Clicked")

        this.setState({
            refundConfirmationVisible: true,
            refundValue: total
        });
    };

    handleChange = (selectedDate) => {

        this.setState({
            datePickerIsOpen: false,
        });

        let obj = this.state.selectedOrderDetail.answers;

        var prepareByDate = ''
        var phoneNumber = ''
        Object.keys(obj).map(function (key) {
            if (obj[key].name === "prepareBy") {
                prepareByDate = key
            } else if (obj[key].name === "phoneNumber") {
                phoneNumber = obj[key].prettyFormat
            }
        })

        var dict = {};
        if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
            dict[prepareByDate] = selectedDate
        } else {
            var unixTimestamp = Math.floor(new Date(selectedDate).getTime()/1000);
            dict[prepareByDate] = unixTimestamp //new Date(selectedDate)
        }

        return this.callUpdateOrder(
            'updateDeliveryTime',
            this.state.selectedOrderDetail.id,
            dict,
            'Order time has been updated and a notification email has been sent to customer.',
            '',
            phoneNumber
        ).then(() => {
            const { user } = this.props;
            var profileImageURL = '';
            if(user.AppUser.ProfileImage && user.AppUser.ProfileImage) {
                profileImageURL = `https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${this.props.user.AppUser.ProfileImage}`;
            }

            let customer = ""
            let orderType = ""
            let email = ""
            let timeZone = ""

            if (this.state.selectedOrderDetail !== "") {
                let obj = this.state.selectedOrderDetail.answers;

                Object.keys(obj).map(function (key) {
                    if (obj[key].name === "name") {
                        customer = obj[key].prettyFormat;
                    } else if (obj[key].name === "pickupdelivery") {
                        orderType = obj[key].answer.toLowerCase()
                            .split(' ')
                            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                            .join(' ');
                        orderType = (orderType === "Doordash_delivery" ? 'DoorDash Delivery' : orderType);
                    }  else if (obj[key].name === "email") {
                        email = obj[key].answer
                    }
                    else if (obj[key].name === "scheduleDeliveryFor") {
                        if (obj[key].answer !== null && obj[key].answer !== undefined) {
                            timeZone = obj[key].answer["timezone"]
                        } else if (obj[key].answers !== null && obj[key].answers !== undefined) {
                            timeZone = obj[key].answers["timezone"]
                        }
                    } else if (obj[key].name === "schedulePickupFor") {
                        if (obj[key].answer !== null && obj[key].answer !== undefined) {
                            timeZone = obj[key].answer["timezone"]
                        } else if (obj[key].answers !== null && obj[key].answers !== undefined) {
                            timeZone = obj[key].answers["timezone"]
                        }
                    }
                })
            }

            let changedPickupDelivery_date = moment.utc(selectedDate).format('ddd, MMM Do');
            let changedPickupDelivery_time = moment.utc(selectedDate).format('h:mm A');
            let changedPickupDelivery_timeZone_date = ""
            let changedPickupDelivery_timeZone_time = ""
            if (this.props.user.BusinessUser.OnlineOrderFormType !== "jotform") {
                if (timeZone !== undefined && timeZone !== "" && timeZone !== null) {
                    timeZone = timeZone.split(' ')[0]
                    let utcdatetime = changedPickupDelivery_date + " " + changedPickupDelivery_time
                    changedPickupDelivery_timeZone_date = moment.utc(utcdatetime, "ddd, MMM Do h:mm A").tz(timeZone).format('ddd, MMM Do');
                    changedPickupDelivery_timeZone_time = moment.utc(utcdatetime, "ddd, MMM Do h:mm A").tz(timeZone).format('h:mm A');
                }
                // changedPickupDelivery_local_date = changedPickupDelivery_date.local().format('ddd, MMM Do');
                // changedPickupDelivery_local_time = changedPickupDelivery_time.local().format('h:mm A');
            }
            let datetime = (changedPickupDelivery_timeZone_date !== "" ? changedPickupDelivery_timeZone_date : changedPickupDelivery_date) + ' at ' + (changedPickupDelivery_timeZone_time !== "" ? changedPickupDelivery_timeZone_time : changedPickupDelivery_time)

            this.props.sendMail(user.AppUser.Email,email,'OrderPrepareByDateTime',profileImageURL,user.AppUser.FirstName,this.onTextChange(user.AppUser.PhoneNo),customer,datetime,orderType).then((data) => {
                if (data.results.ResponseCode === true) {

                } else {

                }
            });

            this.callGetOrder(this.state.selectedDropDownvalue)
        });
    }

    openDatePicker = (id) => {

        let obj = this.state.order[id];

        this.setState({
            datePickerIsOpen: true,
            selectedOrderDetail: obj
        });
    };

    closeDatePicker = () => {

        this.setState({
            datePickerIsOpen: false
        });
    };

    alertCallback = () => {
        this.setState({
            showError: false,
            showSuccess: false,
            // showAlert: !this.state.showAlert
        })
    };

    customerPrintReceipt = (index) => {
        var dict = {};
        if (this.state.openPanel && this.state.selectedOrderDetail !== undefined) {
            dict["fid"] = this.props.user.BusinessUser.OnlineOrderFormId
            dict["orderId"] = this.state.selectedOrderDetail.id
            dict["reciptType"] = "1"
            this.props.printReceipt(`https://print.ubme.com/starcloudprntAPI`,dict).then(() => {
                this.setState({
                    // showAlert: !this.state.showAlert,
                    showSuccess: true,
                    showError: false,
                    msg: 'Customer receipt has been printed.',
                });

                this.hideRightSideViewWithoutClick()
            });
        } else if (index !== undefined) {
            dict["fid"] = this.props.user.BusinessUser.OnlineOrderFormId
            dict["orderId"] = this.props.order[index].id
            dict["reciptType"] = "1"
            this.props.printReceipt(`https://print.ubme.com/starcloudprntAPI`,dict).then(() => {
                this.setState({
                    // showAlert: !this.state.showAlert,
                    showSuccess: true,
                    showError: false,
                    msg: 'Customer receipt has been printed.',
                });
            });
        }

        // if (index !== undefined && index !== '') {
        //     this.state.customerSelectedIndex = index
        // }
        //
        // this.setState({
        //     isCustomerToPrint: true,
        // }, () => {
        //
        //     setTimeout(()    => {
        //
        //         const printableElements = document.getElementById('customerPrintme');
        //         const oldPage = document.body.innerHTML;
        //         const orderHtml = '<html><head><title></title></head><body>' + printableElements.innerHTML + '</body></html>'
        //
        //         var myWindow = window.open('', '', 'fullscreen=yes,height=\'100%\', width=\'100%\'');
        //         // myWindow.document.write('<link rel="stylesheet" href="Orders.css">');
        //         // myWindow.document.write('<style type="text/css">.style1{width: 100%;}</style>');
        //         // myWindow.document.write(orderHtml);
        //         myWindow.document.body.innerHTML = printableElements.innerHTML
        //
        //         // setTimeout(()    => {
        //         //     myWindow.close();
        //         // }, 2000);
        //         myWindow.print();
        //
        //         // try {
        //         //     // Print for Safari browser
        //         //     document.execCommand('print', false, null)
        //         // } catch {
        //         //     myWindow.print();
        //         // }
        //
        //         myWindow.close();
        //
        //     // setTimeout(() => {
        //
        //         // const printableElements = document.getElementById('customerPrintme');
        //
        //         // html2canvas(printableElements,{useCORS: true}).then((canvas) => {
        //
        //             // let imgData = canvas.toDataURL('image/png');
        //             // console.log(imgData);
        //
        //          //   window.open(imgData);
        //
        //             // this.printerConnection('http://localhost:8080/starcloudprnt');
        //
        //             // const dataURL = canvas.toDataURL('image/png');
        //             // const pdf = new jsPDF();
        //             //
        //             // pdf.addImage(dataURL, 'JPEG', 0, 0, 0, 210);
        //             //
        //             // pdf.save('saved.pdf')
        //         // })
        //
        //         this.setState({
        //             isCustomerToPrint: false,
        //             customerSelectedIndex: '',
        //         })
        //     }, 1000);
        // })
    }

    kitchenPrintReceipt = (index) => {

        var dict = {};
        if (this.state.openPanel && this.state.selectedOrderDetail !== undefined) {
            dict["fid"] = this.props.user.BusinessUser.OnlineOrderFormId
            dict["orderId"] = this.state.selectedOrderDetail.id
            dict["reciptType"] = "0"
            this.props.printReceipt(`https://print.ubme.com/starcloudprntAPI`,dict).then(() => {
                this.setState({
                    // showAlert: !this.state.showAlert,
                    showSuccess: true,
                    showError: false,
                    msg: 'Kitchen order has been printed.',
                });

                this.hideRightSideViewWithoutClick()
            });
        } else if (index !== undefined) {
            dict["fid"] = this.props.user.BusinessUser.OnlineOrderFormId
            dict["orderId"] = this.props.order[index].id
            dict["reciptType"] = "0"
            this.props.printReceipt(`https://print.ubme.com/starcloudprntAPI`,dict).then(() => {
                this.setState({
                    // showAlert: !this.state.showAlert,
                    showSuccess: true,
                    showError: false,
                    msg: 'Kitchen order has been printed.',
                });
            });
        }
    }

    fullScreenNotificationCallbackFunction = (showNewOrderReceivedWindow) => {

        this.setState({showNewOrderReceivedWindow: showNewOrderReceivedWindow,
        },  () => {
            audioFunc(true,false,'');
            localStorage.setItem('newOrderCount', '');
            if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
                localStorage.setItem('orderCount', this.state.order.length);
            } else {
                localStorage.setItem('orderCount', this.props.orderReducer.totalOrders);
            }
        });
    }

    formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            var intlCode = (match[1] ? '+1 ' : '');
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return null;
    }

    setRefundTextValue = (event) => {
        this.setState({refundTextValue: event.target.value});
    }

    handleChangePage = (event, page) => {
        this.setState({
                page,
                order: undefined
            },
            () => {
                this.callGetOrder(this.state.selectedDropDownvalue)
        });
    };

    render() {

        const {classes} = this.props;
        const {page, rowsPerPage, order, openPanel, selectedDropDownvalue, selectedOrderDetail, deleteConfirmationVisible, markAsCompleteConfirmationVisible, markAsCancelConfirmationVisible, refundConfirmationVisible, isCustomerToPrint, selectedOrder, customerSelectedIndex, refundValue, maximumRefundValue, size= this.props.orderReducer.totalOrders ? this.props.orderReducer.totalOrders : 0 } = this.state;

        if (selectedOrder !== undefined && selectedOrder !== "") {
            this.state.selectedOrderDetail = selectedOrder
        }

        if (refundValue !== undefined && refundValue !== "" && (maximumRefundValue === undefined || maximumRefundValue === "")) {
            this.state.maximumRefundValue = refundValue
        }

        var windowWidth = window.innerWidth
        if ( windowWidth <= 649) {
            windowWidth = 100
        } else if (windowWidth >= 650 && windowWidth <= 799) {
            windowWidth = 60
        } else if (windowWidth >= 800 && windowWidth <= 1400) {
            windowWidth = 50
        } else {
            windowWidth = 35
        }

        var cssWindowWidth = windowWidth.toString() + "%"

        var totalAmount = 0
        if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
            order && order.length > 0 &&
            order.slice(0, order.length).map((data, index) => {
                if (this.state.order[index].status !== "DELETED") {
                    let obj = this.state.order[index].answers;

                    Object.keys(obj).map(function (key) {
                        if (obj[key].name === "total") {
                            if (obj[key].answer !== undefined && obj[key].answer !== null) {
                                var SampleText = obj[key].answer.toString();
                                var NewText = SampleText.replace("$", "");
                                totalAmount = totalAmount + Number(NewText)
                                totalAmount = +totalAmount.toFixed(2);
                            }
                        }
                    })
                }
            })
        }

        if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
            if (this.state.newDataReceived && order !== undefined && order !== "" && selectedDropDownvalue !== undefined && selectedDropDownvalue !== "") {
                this.setState({
                    newDataReceived: false
                })
                this.handleChangeDropDown(selectedDropDownvalue)
            }
        }

        return (
            <div name="mainDiv" style={{overflowX: "auto"}} onClick={(e) => this.hideRightSideView('', e)}>
                <Grid container spacing={24}>
                    <Alert onClose={this.alertCallback} showSuccess={this.state.showSuccess} showError={this.state.showError}
                           Msg={this.state.msg} />
                </Grid>

                {/*{this.state.isCustomerToPrint &&*/}
                {/*<CustomerReceiptToPrint printableId="customerPrintme" order={order} openPanel={openPanel}*/}
                {/*                        user={this.props.user}*/}
                {/*                        selectedOrderDetail={order[customerSelectedIndex] ? order[customerSelectedIndex] : selectedOrderDetail}/>*/}
                {/*}*/}

                {/*{this.state.isKitchenToPrint &&*/}
                {/*<KitchenReceiptToPrint printableId="kitchenPrintme" order={order} openPanel={openPanel}*/}
                {/*                       user={this.props.user}*/}
                {/*                       selectedOrderDetail={order[kitchenSelectedIndex] ? order[kitchenSelectedIndex] : selectedOrderDetail}/>*/}
                {/*}*/}

                {this.state.deleteConfirmationVisible &&
                <Dialog
                    open={deleteConfirmationVisible}
                    onClose={this.cancelDelete}
                >
                    <DialogTitle>
                        Delete Order
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this order?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.toggleDeleteConfirmationVisible} color="primary" variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={this.callDeleteOrderApi} color="secondary" variant="outlined">
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
                }

                {this.state.markAsCompleteConfirmationVisible &&
                <Dialog
                    open={markAsCompleteConfirmationVisible}
                    onClose={this.cancelDelete}
                >
                    <DialogTitle>
                        Mark As Complete
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to mark this order as complete?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.toggleMarkAsCompleteConfirmationVisible} color="primary"
                                variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={this.callMarkAsCompleteOrderApi} color="secondary" variant="outlined">
                            Mark As Complete
                        </Button>
                    </DialogActions>
                </Dialog>
                }

                {this.state.refundConfirmationVisible &&
                    <Dialog
                        open={refundConfirmationVisible}
                        onClose={this.cancelDelete}
                    >
                        <DialogTitle>
                            Refund Payment
                        </DialogTitle>
                        <DialogContent>
                            {/*<DialogContentText>*/}
                            {/*    Are you sure you want to issue a refund for this transaction?*/}
                            {/*</DialogContentText>*/}
                            {/*<TextField*/}
                            {/*    autoFocus*/}
                            {/*    // margin="dense"*/}
                            {/*    // id="name"*/}
                            {/*    label="Refund"*/}
                            {/*    type="number"*/}
                            {/*    placeholder="Amount"*/}
                            {/*    style={{width:'400px'}}*/}
                            {/*    // onChange={this.setRefundTextValue}*/}
                            {/*    value={this.state.refundValue}*/}
                            {/*    onChange={(e) => {*/}
                            {/*        let input = e.target.value ;*/}
                            {/*        if( !input || ( input[input.length-1].match('[0-9]') && input[0].match('[1-9]')) )*/}
                            {/*            this.setState({refundValue:input})*/}
                            {/*    }}*/}
                            {/*/>*/}
                            <CurrencyTextField
                                label="Amount"
                                variant="standard"
                                value={this.state.refundValue}
                                currencySymbol="$"
                                outputFormat="string"
                                onChange={(event, value)=> this.setState({refundValue:value})}
                                autoFocus
                                style={{width:'400px'}}
                                maximumValue={this.state.maximumRefundValue}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.toggleRefundConfirmationVisible} color="primary"
                                    variant="outlined">
                                Cancel
                            </Button>
                            <Button onClick={this.callRefundApi} color="secondary" variant="outlined">
                                Refund
                            </Button>
                        </DialogActions>
                    </Dialog>
                }

                {this.state.markAsCancelConfirmationVisible &&
                <Dialog
                    open={markAsCancelConfirmationVisible}
                    onClose={this.cancelDelete}
                >
                    <DialogTitle>
                        Cancel Order
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to cancel this order?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.toggleMarkAsCancelConfirmationVisible} color="primary" variant="outlined">
                            Nevermind
                        </Button>
                        <Button onClick={this.callMarkAsCancelOrderApi} color="secondary" variant="outlined">
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
                }

                <div style={{display:'flex'}}>
                    <NativeSelect
                        name="OrderStatus"
                        onChange={(e) => this.handleChangeDropDown('', e)}
                        inputProps={{
                            className: classes.select
                        }}
                        value={selectedDropDownvalue}
                    >
                        <option value={'All'}>All</option>
                        <option value={'Active'}>Active</option>
                        <option value={'Completed'}>Completed</option>
                        <option value={'Cancelled'}>Cancelled</option>
                    </NativeSelect>

                    {order && order.length > 0
                        ?
                        order.slice(0, 1).map((data, index) => {
                            if (order[index].status !== "DELETED") {
                                return (
                                    <div style={{
                                        height: '50px',
                                        display: 'flex',
                                        marginLeft: 'auto',
                                    }}>
                                        <IconButton onClick={this.showMessagePopup}
                                                    id="textSmsOutlined" style={{height: '-webkit-fill-available', color: '#4CAF50', margin:'10px'}} name="textSmsOutlined">
                                            <TextsmsOutlinedIcon fontSize="large"/>
                                        </IconButton>
                                        <div style={{
                                            backgroundColor: '#4CAF50',
                                            display: 'flex',
                                        }}>
                                            {this.props.user.BusinessUser.OnlineOrderFormType === "jotform" ?
                                                <label className="textTotalOrderInPast30Days"><b>{order.length}</b>{this.state.selectedDropDownvalue === "Active" ? ' active' : this.state.selectedDropDownvalue === "Completed" ? ' completed' : this.state.selectedDropDownvalue === "Cancelled" ? ' cancelled' : ""} {order.length == 1 ? 'order' : 'orders'} in the past 7 days, for a total
                                                    of <b>${totalAmount}</b></label> :
                                                <label className="textTotalOrderInPast30Days"><b>{this.props.orderReducer.totalOrders > 0 ? this.props.orderReducer.totalOrders : 0}</b>{this.state.selectedDropDownvalue === "Active" ? ' active' : this.state.selectedDropDownvalue === "Completed" ? ' completed' : this.state.selectedDropDownvalue === "Cancelled" ? ' cancelled' : ""} {this.props.orderReducer.totalOrders == 1 ? 'order' : 'orders'} in the past 7 days, for a total
                                                    of <b>${this.props.orderReducer.totalAmount}</b></label>
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        })
                        :
                        (() => {
                            if (order === undefined || order === "") {
                                return (
                                    <div style={{
                                        height: '50px',
                                        float: 'right',
                                        display: 'flex',
                                        marginBottom: '10px',
                                        textAlign: 'right',
                                    }}>
                                        <IconButton onClick={this.showMessagePopup}
                                                    id="textSmsOutlined" style={{height: '-webkit-fill-available', color: '#4CAF50', margin:'10px'}} name="textSmsOutlined">
                                            <TextsmsOutlinedIcon fontSize="large"/>
                                        </IconButton>
                                        <div style={{
                                            backgroundColor: '#4CAF50',
                                            display: 'flex',
                                        }}>
                                            <label className="textTotalOrderInPast30Days"><b>0</b> order in the past 7 days, for a total of <b>$0</b></label>
                                        </div>
                                    </div>
                                )
                            }
                        })
                    }
                </div>

                { this.state.datePickerIsOpen === true ?
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <DateTimePicker
                            open={this.state.datePickerIsOpen}
                            onChange={(selectedDate) => this.handleChange(selectedDate)}
                            // InputProps={{
                            //     disableUnderline: true,
                            // }}
                            TextFieldComponent={() => null}
                            onClose={() => this.closeDatePicker()}
                        />
                    </MuiPickersUtilsProvider> : ""
                }

                { this.state.showMessagePopup === true ?
                    <Modal
                        open={true}
                        onClose=""
                    >
                        <div className="messageModal">
                            <div style={{display:'flex'}}>
                                <div>
                                    <img
                                        src={require('../../../images/orderIcons/order_notify.png')}
                                        className="messagePopupNotifyIcon"/>
                                    <label style={{
                                        alignSelf: 'center',
                                        padding: '5px',
                                        fontSize: '14px',
                                        marginTop: '5px',
                                        fontWeight: 'bolder',
                                        textAlign: 'center'
                                    }}>
                                        When you click "notify", below is a copy of the text message your customer will receive.
                                    </label>
                                    <div style={{height:"1px",backgroundColor:"#e1e1e1",marginLeft:"30px"}} />
                                    <textarea id="onlineOrderMessage" name="onlineOrderMessage" className="messageTextArea" value={this.state.onlineOrderMessageValue}
                                              onChange={this.handleOnlineOrderMessageChange}/>
                                    <div className="messageModalSaveCancelDiv">
                                        <Button className={classes.btnSave} onClick={() => this.callSaveMessageAPI()}>SAVE</Button>
                                        <Button className={classes.btnSave} onClick={this.hideMessagePopup}>CANCEL</Button>
                                    </div>
                                </div>
                                <div>
                                    <IconButton color="inherit" onClick={this.hideMessagePopup} aria-label="Close" className="close-btn-edit-modal" >
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    : ""}

                <SlidingPanel
                    type={'right'}
                    isOpen={openPanel}
                    size={windowWidth}
                    panelClassName={classes.slidingPanel}>
                    {order && order.length > 0 && selectedOrderDetail && order.slice(0, 1).map(() => {
                        if (selectedOrderDetail.status !== "DELETED") {

                            let obj = selectedOrderDetail.answers;

                            let isactiveOrCompleted = ""
                            let isNotifiedUser = ""

                            let orderType = ""

                            let created_date
                            let created_time

                            let customer = ""
                            let deliveryAddress = ""
                            let deliveryAddress2 = ""
                            let address2 = ""
                            let state = ""
                            let city = ""
                            let postal = ""
                            let phonenumber = ""
                            let email = ""

                            let foodInstructions = ""
                            let deliveryInstructions = ""

                            let orderDetails = []

                            let subTotal = ""
                            let orderFee = ""
                            let tax = ""
                            let taxKeyword = ""
                            let tip = ""
                            let total = "-"

                            let prepare_by_date = ""
                            let prepare_by_time = "-"
                            let timeZone = ""

                            let prettyFormat = ""

                            let onlineOrderFormType = this.props.user.BusinessUser.OnlineOrderFormType

                            Object.keys(obj).map((key) => {
                                if (obj[key].name === "name") {
                                    customer = obj[key].prettyFormat;
                                } else if (obj[key].name === "deliveryAddress") {
                                    if (obj[key].answer !== undefined && obj[key].answer !== null && obj[key].answer !== "") {
                                        if (obj[key].answer["addr_line1"] !== "" && obj[key].answer["addr_line1"] !== undefined) {
                                            deliveryAddress = obj[key].answer["addr_line1"]
                                        }
                                        deliveryAddress2 = obj[key].answer["addr_line2"]
                                        state = obj[key].answer["state"]
                                        city = obj[key].answer["city"]
                                        postal = obj[key].answer["postal"]
                                        if (deliveryAddress2 !== "") {
                                            address2 = deliveryAddress2
                                        }
                                        if (city !== "") {
                                            address2 = address2 !== "" ? address2 + ', ' + city : city
                                        }
                                        if (state !== "") {
                                            address2 = address2 !== "" ? address2 + ', ' + state : state
                                        }
                                        if (postal !== "") {
                                            address2 = address2 !== "" ? address2 + ' ' + postal : postal
                                        }
                                    } else if (obj[key].prettyFormat !== undefined && obj[key].prettyFormat !== null && obj[key].prettyFormat !== "") {
                                        deliveryAddress = obj[key].prettyFormat
                                    }
                                } else if (obj[key].name === "phoneNumber") {
                                    phonenumber = this.formatPhoneNumber(obj[key].prettyFormat)
                                } else if (obj[key].name === "email") {
                                    email = obj[key].answer
                                } else if (obj[key].name === "foodInstructions") {
                                    foodInstructions = obj[key].answer
                                } else if (obj[key].name === "deliveryInstructions") {
                                    deliveryInstructions = obj[key].answer
                                } else if (obj[key].name === "orderDetails") {
                                    prettyFormat = obj[key].prettyFormat
                                    let obj1 = ""
                                    if (obj[key].answers !== null && obj[key].answers !== undefined) {
                                        obj1 = obj[key].answers
                                    } else {
                                        obj1 = obj[key].answer
                                    }
                                    orderDetails.push({
                                        obj1
                                    })
                                } else if (obj[key].name === "scheduleDeliveryFor") {
                                    if (obj[key].answer !== null && obj[key].answer !== undefined) {
                                        timeZone = obj[key].answer["timezone"]
                                    } else if (obj[key].answers !== null && obj[key].answers !== undefined) {
                                        timeZone = obj[key].answers["timezone"]
                                    }
                                } else if (obj[key].name === "schedulePickupFor") {
                                    if (obj[key].answer !== null && obj[key].answer !== undefined) {
                                        timeZone = obj[key].answer["timezone"]
                                    } else if (obj[key].answers !== null && obj[key].answers !== undefined) {
                                        timeZone = obj[key].answers["timezone"]
                                    }
                                } else if (obj[key].name === "prepareBy") {
                                    let strDateTime = obj[key].answer ? obj[key].answer : ""
                                    if (strDateTime !== "") {
                                        var valid = moment(strDateTime).isValid()
                                        if (valid) {
                                            if (onlineOrderFormType === "jotform") {
                                                prepare_by_date = moment.utc(strDateTime).format('ddd, MMM Do');
                                                prepare_by_time = moment.utc(strDateTime).format('h:mm A');
                                            } else {
                                                prepare_by_date = moment.utc(strDateTime).local().format('ddd, MMM Do');
                                                prepare_by_time = moment.utc(strDateTime).local().format('h:mm A');
                                            }
                                        } else {
                                            var unixTimeStamp = Number(strDateTime);
                                            if (unixTimeStamp > 0) {
                                                var localDateTime = moment(unixTimeStamp).format("YYYY-MM-DD HH:mm:ss");
                                                var dateTimeInUtc = momentTz.tz(localDateTime, "YYYY-MM-DD HH:mm:ss").utc().format("YYYY-MM-DD HH:mm:ss");
                                                if (timeZone !== undefined && timeZone !== "" && timeZone !== null) {
                                                    if (onlineOrderFormType === "jotform") {
                                                        timeZone = timeZone.split(' ')[0]
                                                        prepare_by_date = moment(dateTimeInUtc, "YYYY-MM-DD HH:mm:ss").tz(timeZone).format('ddd, MMM Do');
                                                        prepare_by_time = moment(dateTimeInUtc, "YYYY-MM-DD HH:mm:ss").tz(timeZone).format('h:mm A');
                                                    } else {
                                                        prepare_by_date = moment.utc(dateTimeInUtc).local().format('ddd, MMM Do');
                                                        prepare_by_time = moment.utc(dateTimeInUtc).local().format('h:mm A');
                                                    }
                                                } else {
                                                    if (onlineOrderFormType === "jotform") {
                                                        prepare_by_date = moment(dateTimeInUtc, "YYYY-MM-DD HH:mm:ss").format('ddd, MMM Do');
                                                        prepare_by_time = moment(dateTimeInUtc, "YYYY-MM-DD HH:mm:ss").format('h:mm A');
                                                    } else {
                                                        prepare_by_date = moment.utc(dateTimeInUtc).local().format('ddd, MMM Do');
                                                        prepare_by_time = moment.utc(dateTimeInUtc).local().format('h:mm A');
                                                    }

                                                }
                                            }
                                        }
                                    }
                                } else if (obj[key].name === "pickupdelivery") {
                                    orderType = obj[key].answer.toLowerCase()
                                        .split(' ')
                                        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                                        .join(' ');
                                    orderType = (orderType === "Doordash_delivery" ? 'DoorDash Delivery' : orderType);
                                } else if (obj[key].name === "total") {
                                    total = obj[key].answer
                                } else if (obj[key].name === "isactiveorcompleted") {
                                    isactiveOrCompleted = obj[key].answer;
                                } else if (obj[key].name === "isnotifieduser") {
                                    isNotifiedUser = obj[key].answer;
                                }
                            })

                            if (timeZone !== undefined && timeZone !== "" && timeZone !== null) {
                                timeZone = timeZone.split(' ')[0]
                                var dateTimeInUtc =  momentTz.tz(selectedOrderDetail.created_at, "YYYY-MM-DD HH:mm:ss", "America/New_York").utc().format("YYYY-MM-DD HH:mm:ss");
                                if (onlineOrderFormType === "jotform") {
                                    created_date = moment.utc(dateTimeInUtc, "YYYY-MM-DD HH:mm:ss").tz(timeZone).format('ddd, MMM Do');
                                    created_time = moment.utc(dateTimeInUtc, "YYYY-MM-DD HH:mm:ss").tz(timeZone).format('h:mm A');
                                } else {
                                    created_date = moment.utc(selectedOrderDetail.created_at).local().format('ddd, MMM Do');
                                    created_time = moment.utc(selectedOrderDetail.created_at).local().format('h:mm A');
                                }
                            } else {
                                if (onlineOrderFormType === "jotform") {
                                    created_date = moment.utc(selectedOrderDetail.created_at).format('ddd, MMM Do');
                                    created_time = moment.utc(selectedOrderDetail.created_at).format('h:mm A');
                                } else {
                                    created_date = moment.utc(selectedOrderDetail.created_at).local().format('ddd, MMM Do');
                                    created_time = moment.utc(selectedOrderDetail.created_at).local().format('h:mm A');
                                }
                            }

                            if (onlineOrderFormType === "wordpress" && prepare_by_date === "" && prepare_by_time === "-" && created_date !== "" && created_time !== "") {
                                // prepare_by_date = created_date
                                // prepare_by_time = moment(created_time).add(30, 'minutes').format('h:mm A');
                                let dateTime = moment(created_date + ' ' + created_time, 'ddd, MMM Do h:mm A')
                                prepare_by_date = moment(dateTime, 'ddd, MMM Do h:mm A').format('ddd, MMM Do')
                                prepare_by_time = moment(dateTime, 'ddd, MMM Do h:mm A').add(30, 'minutes').format('h:mm A');
                            }

                            return (
                                <div style={{marginTop: '40px'}}>
                                    <div style={{
                                        backgroundColor: '#e1e1e1',
                                        height: '60px',
                                        position: 'fixed',
                                        width: cssWindowWidth
                                    }}>
                                        <IconButton onClick={(e) => this.hideRightSideView('closeButton', e)}
                                                    id="closeButton" style={{height: '-webkit-fill-available'}}>
                                            <CancelIcon fontSize="large"/>
                                        </IconButton>
                                        <label style={{
                                            textAlign: 'center',
                                            margin: 'auto',
                                            verticalAlign: 'middle',
                                            // transform: 'translateY(-160%)',
                                            display: 'inline-block',
                                            width: '80%',
                                            fontsize: '3v'
                                        }}>{orderType}</label>
                                    </div>
                                    <div className="scrollableDiv">
                                        <div className="div-print-delete-complete">
                                            <button className="btn-print-delete-complete"
                                                    onClick={() => this.customerPrintReceipt()}>
                                                Receipt
                                            </button>
                                            {/*<button className="btn-print-delete-complete"*/}
                                            {/*        onClick={() => this.kitchenPrintReceipt()}>*/}
                                            {/*    Send*/}
                                            {/*</button>*/}
                                            { orderType !== "Delivery" && orderType !== "DoorDash Delivery" ?
                                                isNotifiedUser === "Yes" ?
                                                    <button className="btn-disabled-print-delete-complete" disabled>
                                                        Notified
                                                    </button>
                                                    : <button className="btn-print-delete-complete"
                                                              onClick={(e) => this.callSendMessageApi('', e)}>
                                                        Notify
                                                    </button>

                                                : ""
                                            }
                                            {isactiveOrCompleted !== "Completed" && isactiveOrCompleted !== "Cancelled" ?
                                                <button className="btn-print-delete-complete"
                                                        onClick={this.markAsCancelOrderClicked}>
                                                    Cancel Order
                                                </button> :
                                                <button disabled className="btn-disabled-print-delete-complete">
                                                    Cancel Order
                                                </button>
                                            }
                                            {isactiveOrCompleted === "Active" || isactiveOrCompleted === "processing" ?
                                                <button className="btn-print-delete-complete"
                                                        onClick={this.markAsCompleteOrderClicked}>
                                                    Mark as complete
                                                </button> :
                                                <button disabled className="btn-disabled-print-delete-complete">
                                                    Mark as complete
                                                </button>
                                            }
                                        </div>
                                        <div className="seperator" />
                                        <div className="div-orderPlacedOn-Name">
                                            <div className="div-orderplacedOn">
                                                <div>
                                                    <label className="lbl-orderplacedOn"> Time ordered: </label>
                                                </div>
                                                <div>
                                                    <label
                                                        className="lbl-orderplacedOn-text">{created_date} - {created_time} </label>
                                                </div>
                                            </div>
                                            <div className="div-customer">
                                                <div>
                                                    <label className="lbl-orderplacedOn"> {customer} </label>
                                                </div>
                                                {deliveryAddress !== "" && deliveryAddress !== undefined && deliveryAddress !== null ?
                                                    <div>
                                                        <label
                                                            className="lbl-orderplacedOn-text">{deliveryAddress}</label>
                                                    </div>
                                                    :
                                                    ""
                                                }
                                                {address2 !== "" && address2 !== undefined && address2 !== null ?
                                                    <div className="div-parent">
                                                        <label className="lbl-orderplacedOn-text">{address2}</label>
                                                    </div>
                                                    :
                                                    phonenumber !== "" && phonenumber !== undefined && phonenumber !== null ?
                                                        <div>
                                                            <label
                                                                className="lbl-orderplacedOn-text">{phonenumber}</label>
                                                        </div>
                                                        :
                                                        email !== "" && email !== undefined && email !== null ?
                                                            <div>
                                                                <label
                                                                    className="lbl-orderplacedOn-text">{email}</label>
                                                            </div>
                                                            : ""
                                                }
                                                {address2 !== "" && address2 !== undefined && address2 !== null ?
                                                    phonenumber !== "" && phonenumber !== undefined ?
                                                        <div>
                                                            <label
                                                                className="lbl-orderplacedOn-text">{phonenumber}</label>
                                                        </div>
                                                        :
                                                        email !== "" && email !== undefined && email !== null ?
                                                            <div>
                                                                <label
                                                                    className="lbl-orderplacedOn-text">{email}</label>
                                                            </div>
                                                            : ""
                                                    : ""
                                                }
                                                {phonenumber !== "" && phonenumber !== undefined && phonenumber !== null ?
                                                    email !== "" && email !== undefined ?
                                                        <div>
                                                            <label className="lbl-orderplacedOn-text">{email}</label>
                                                        </div>
                                                        : ""
                                                    : ""
                                                }
                                            </div>
                                        </div>
                                        {deliveryInstructions !== "" && deliveryInstructions !== undefined && deliveryInstructions !== null ?
                                            <div className="div-Instructions">
                                                <div>
                                                    <label className="lbl-orderplacedOn"> Delivery
                                                        Instructions: </label>
                                                </div>
                                                <div>
                                                    <label className="lbl-orderplacedOn-text"
                                                           dangerouslySetInnerHTML={{__html: deliveryInstructions}} />
                                                </div>
                                            </div> : ""
                                        }
                                        {foodInstructions !== "" && foodInstructions !== undefined && foodInstructions !== null ?
                                            <div className="div-Instructions">
                                                <div>
                                                    <label className="lbl-orderplacedOn" style={{color: 'red'}}> Food
                                                        Instructions: </label>
                                                </div>
                                                <div>
                                                    <label className="lbl-orderplacedOn-text"
                                                           dangerouslySetInnerHTML={{__html: foodInstructions}} />
                                                </div>
                                            </div> : ""
                                        }
                                        {orderDetails.map((orderDetailsObj, index) => {
                                            let  obj2 = orderDetails[index]["obj1"];

                                            let objAns = ""
                                            if (this.props.user.BusinessUser.OnlineOrderFormType !== "jotform") {
                                                objAns = obj2["ans"]
                                            }

                                            if (obj2["paymentArray"] !== undefined && obj2["paymentArray"] !== null) {
                                                let arrPayment = JSON.parse(obj2["paymentArray"])

                                                if (arrPayment !== "" && arrPayment !== undefined && arrPayment !== null) {
                                                    if (arrPayment.subtotal !== undefined) {
                                                        subTotal = (Math.round(arrPayment.subtotal * 100) / 100).toFixed(2)
                                                    }
                                                    if (arrPayment.orderFee !== undefined) {
                                                        orderFee = (Math.round(arrPayment.orderFee * 100) / 100).toFixed(2)
                                                    }
                                                    if (arrPayment.tax !== undefined) {
                                                        taxKeyword = obj2["paymentArray"].includes("tax") ? "Taxes" : "Service Charge"
                                                        tax = (Math.round(arrPayment.tax * 100) / 100).toFixed(2)
                                                    }
                                                }
                                            }

                                            if (this.props.user.BusinessUser.OnlineOrderFormType !== "jotform") {
                                                obj2 = objAns
                                            }

                                            return (
                                                <div style={{marginTop: '10px'}}>
                                                    <Table className={classes.table}>
                                                        <TableHead>
                                                            <TableRow className={classes.tableRow}
                                                                      style={{background: "#563c5c"}}>
                                                                <TableCell
                                                                    className={classes.orderDetailHeaderItemDescriptionCell}>
                                                                    Item Description
                                                                </TableCell>
                                                                <TableCell className={classes.orderDetailHeaderCell}>
                                                                    Quantity
                                                                </TableCell>
                                                                <TableCell className={classes.orderDetailHeaderCell}>
                                                                    Price
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {Object.keys(obj2).map(function (key) {
                                                                let data = ""

                                                                try {
                                                                    // Parse a JSON
                                                                    data = (objAns !== null  && objAns !== undefined && objAns !== "") ? obj2[key] : JSON.parse(obj2[key]);
                                                                } catch (e) {
                                                                    data = ""
                                                                }

                                                                if (data !== null && data !== "" && data !== undefined && data.name !== "" && data.name !== undefined && data.name !== null) {
                                                                    if (data.name === "Tip" && data.options !== undefined && data.options !== "" && data.options !== null) {
                                                                        var SampleText = data.options[0].selected.toString();
                                                                        var NewText = SampleText.replace("$", "");
                                                                        tip = (Math.round(NewText * 100) / 100).toFixed(2)
                                                                    }
                                                                }

                                                                if (data !== null &&  data !== "" && data !== undefined && data.name !== "" && data.name !== undefined && data.name !== null && data.name !== "Tip") {
                                                                    return (
                                                                        <TableRow className={classes.tableRow}
                                                                                  style={{background: "#F8F8F7"}}>
                                                                            <TableCell
                                                                                className={classes.orderDetailCell}>
                                                                                <div style={{fontWeight: '700'}}>
                                                                                    {data.name}
                                                                                </div>
                                                                                {(data.options !== null && data.options !== undefined) && Object.keys(data.options).map(function (key) {
                                                                                    let dataOptions = data.options[key] //JSON.parse()

                                                                                    if (dataOptions.name !== "Quantity") {
                                                                                        return (<div style={{
                                                                                            marginLeft: '10px',
                                                                                            fontWeight: '200',
                                                                                            display: 'list-item',
                                                                                            listStylePosition: 'inside'
                                                                                        }}>
                                                                                            {(dataOptions.price !== null && dataOptions.price !== undefined && dataOptions.price !== "")  ? (dataOptions.name + " - " + dataOptions.selected + " : " + "$" + dataOptions.price) : (dataOptions.name + " - " + dataOptions.selected)}
                                                                                        </div>)
                                                                                    }
                                                                                })
                                                                                }
                                                                            </TableCell>
                                                                            <TableCell
                                                                                className={classes.orderDetailCellTextAlign}>
                                                                                {data.quantity}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                className={classes.orderDetailCellTextAlign}>
                                                                                ${(Math.round(data.price * 100) / 100).toFixed(2)}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                }
                                                            })
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                </div>
                                            )
                                        })
                                        }
                                        <div className="div-subTotalTaxTotal">
                                            <Table className={classes.table}>
                                                {subTotal !== "" && subTotal !== undefined ?
                                                    <TableHead>
                                                        <TableRow className={classes.tableRow}>
                                                            <TableCell className={classes.subtotalCellTextAlign}>
                                                                Subtotal
                                                            </TableCell>
                                                            <TableCell className={classes.subtotalCellTextAlign}>
                                                                ${subTotal}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead> : ""
                                                }
                                                {orderFee !== "" && orderFee !== undefined ?
                                                    <TableBody>
                                                        <TableRow className={classes.tableRow}>
                                                            <TableCell className={classes.taxTotalCellTextAlign}>
                                                                {(orderType === "Delivery" || orderType === "DoorDash Delivery") ? "Delivery Fee" : "Pick up Fee"}
                                                            </TableCell>
                                                            <TableCell className={classes.taxTotalCellTextAlign}>
                                                                ${orderFee}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                    : ""
                                                }
                                                {tax !== "" && tax !== undefined ?
                                                    <TableBody>
                                                        <TableRow className={classes.tableRow}>
                                                            <TableCell className={classes.taxTotalCellTextAlign}>
                                                                {taxKeyword}
                                                            </TableCell>
                                                            <TableCell className={classes.taxTotalCellTextAlign}>
                                                                ${tax}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                    : ""
                                                }
                                                {tip !== "" && tip !== undefined ?
                                                    <TableHead>
                                                        <TableRow className={classes.tableRow}>
                                                            <TableCell className={classes.subtotalCellTextAlign}
                                                                       style={{color: '#4CAF50'}}>
                                                                Tip
                                                            </TableCell>
                                                            <TableCell className={classes.subtotalCellTextAlign}
                                                                       style={{color: '#4CAF50'}}>
                                                                ${tip}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead> : ""
                                                }
                                                <TableHead>
                                                    <TableRow className={classes.tableRow}>
                                                        <TableCell className={classes.subtotalCellTextAlign}>
                                                            Total
                                                        </TableCell>
                                                        <TableCell className={classes.subtotalCellTextAlign}>
                                                            {total}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                            </Table>
                                        </div>
                                    </div>
                                    <div style={{
                                        position: 'fixed',
                                        display: 'block',
                                        width: cssWindowWidth,
                                        backgroundColor: ' #FFFFFF',
                                        height: '130px',
                                        bottom: '0px'
                                    }}>
                                        {/*<div>*/}
                                        <label
                                            className="lbl-prepareBy">{(orderType === "Delivery" || orderType === "DoorDash Delivery") ? 'Deliver by:' : 'Pick Up at:'}</label>
                                        {/*</div>*/}
                                        {/*<div>*/}
                                        <label
                                            className="lbl-prepareBy-text">{prepare_by_date} - {prepare_by_time}</label>
                                        {/*</div>*/}
                                    </div>
                                </div>
                            )
                        }
                    })
                    }
                </SlidingPanel>

                {this.state.showNewOrderReceivedWindow ?
                    <FullScreenNotification parentCallback = {this.fullScreenNotificationCallbackFunction} /> :

                    <div style={{marginTop: '10px'}}>
                        <Table className={classes.table}>
                            <TableHead className={classes.tableHeader}>
                                {this.state.order && this.state.order.length > 0 && this.state.order.slice(0, 1).map((order, index) => {
                                    if (this.state.order[index].status !== "DELETED") {
                                        let obj = this.state.order[index].answers;
                                        let customer = ""
                                        let created_date = ""
                                        let prepare_by = ""
                                        let total = ""
                                        let orderType = ""

                                        Object.keys(obj).map(function (key) {
                                            if (obj[key].name === "name") {
                                                customer = "Customer"
                                            } else if (obj[key].name === "prepareBy") {
                                                prepare_by = "For"
                                            } else if (obj[key].name === "pickupdelivery") {
                                                orderType = "Order Type";
                                            } else if (obj[key].name === "total") {
                                                total = "Total";
                                            }
                                        })
                                        Object.keys(order).map(function (key) {
                                            if (key === "created_at") {
                                                created_date = "Time ordered";
                                            }
                                        })

                                        return (
                                            <TableRow>
                                                <TableCell className={classes.tableHeaderCell}>
                                                    {customer}
                                                </TableCell>
                                                <TableCell className={classes.tableHeaderCell}>
                                                    {created_date}
                                                </TableCell>
                                                <TableCell className={classes.tableHeaderCell}>
                                                    {prepare_by}
                                                </TableCell>
                                                <TableCell className={classes.tableHeaderCell}>
                                                    {orderType }
                                                </TableCell>
                                                <TableCell className={classes.tableHeaderCell}>
                                                    {total}
                                                </TableCell>
                                                <TableCell className={classes.tableHeaderCell}>
                                                    Actions
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                })
                                }
                            </TableHead>
                            <TableBody>
                                {this.state.order && this.state.order.length > 0 && this.state.order.slice(0, this.state.order.length).map((order, index) => {
                                    if (this.state.order[index].status !== "DELETED") {
                                        let obj = this.state.order[index].answers;

                                        // let created_date1 = moment.utc(this.state.order[index].created_at).format('ddd, MMM Do');
                                        // let created_time1 = moment.utc(this.state.order[index].created_at).format('h:mm A');
                                        let customer = ""
                                        let prepare_by_date = ""
                                        let prepare_by_time = "-"
                                        let total = "-"
                                        let orderType = "-"
                                        let isActiveOrCompleted = ""
                                        let isNotifiedUser = ""
                                        let timeZone = ""
                                        let created_date
                                        let created_time
                                        let refundStatus = ""

                                        let onlineOrderFormType = this.props.user.BusinessUser.OnlineOrderFormType

                                        Object.keys(obj).map(function (key) {
                                            if (obj[key].name === "name") {
                                                customer = obj[key].prettyFormat;
                                            } else if (obj[key].name === "pickupdelivery") {
                                                orderType = obj[key].answer.toLowerCase()
                                                    .split(' ')
                                                    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                                                    .join(' ');
                                                orderType = (orderType === "Doordash_delivery" ? 'DoorDash Delivery' : orderType);
                                            } else if (obj[key].name === "total") {
                                                total = obj[key].answer
                                            } else if (obj[key].name === "isactiveorcompleted") {
                                                isActiveOrCompleted = obj[key].answer
                                            } else if (obj[key].name === "isnotifieduser") {
                                                isNotifiedUser = obj[key].answer;
                                            } else if (obj[key].name === "scheduleDeliveryFor") {
                                                if (obj[key].answer !== null && obj[key].answer !== undefined) {
                                                    timeZone = obj[key].answer["timezone"]
                                                } else if (obj[key].answers !== null && obj[key].answers !== undefined) {
                                                    timeZone = obj[key].answers["timezone"]
                                                }
                                            } else if (obj[key].name === "schedulePickupFor") {
                                                if (obj[key].answer !== null && obj[key].answer !== undefined) {
                                                    timeZone = obj[key].answer["timezone"]
                                                } else if (obj[key].answers !== null  && obj[key].answers !== undefined) {
                                                    timeZone = obj[key].answers["timezone"]
                                                }
                                            } else if (obj[key].name === "prepareBy") {
                                                let strDateTime = obj[key].answer ? obj[key].answer : ""
                                                if (strDateTime !== "") {
                                                    var valid = moment(strDateTime).isValid()
                                                    if (valid) {
                                                        if (onlineOrderFormType === "jotform") {
                                                            prepare_by_date = moment.utc(strDateTime).format('ddd, MMM Do');
                                                            prepare_by_time = moment.utc(strDateTime).format('h:mm A');
                                                        } else {
                                                            prepare_by_date = moment.utc(strDateTime).local().format('ddd, MMM Do');
                                                            prepare_by_time = moment.utc(strDateTime).local().format('h:mm A');
                                                        }
                                                    } else {
                                                        var unixTimeStamp = Number(strDateTime);
                                                        if (unixTimeStamp > 0) {
                                                            var localDateTime = moment(unixTimeStamp).format("YYYY-MM-DD HH:mm:ss");
                                                            var dateTimeInUtc = momentTz.tz(localDateTime, "YYYY-MM-DD HH:mm:ss").utc().format("YYYY-MM-DD HH:mm:ss");
                                                            if (timeZone !== undefined && timeZone !== "" && timeZone !== null) {
                                                                if (onlineOrderFormType === "jotform") {
                                                                    timeZone = timeZone.split(' ')[0]
                                                                    prepare_by_date = moment(dateTimeInUtc, "YYYY-MM-DD HH:mm:ss").tz(timeZone).format('ddd, MMM Do');
                                                                    prepare_by_time = moment(dateTimeInUtc, "YYYY-MM-DD HH:mm:ss").tz(timeZone).format('h:mm A');
                                                                } else {
                                                                    prepare_by_date = moment.utc(dateTimeInUtc).local().format('ddd, MMM Do');
                                                                    prepare_by_time = moment.utc(dateTimeInUtc).local().format('h:mm A');
                                                                }
                                                            } else {
                                                                if (onlineOrderFormType === "jotform") {
                                                                    prepare_by_date = moment(dateTimeInUtc, "YYYY-MM-DD HH:mm:ss").format('ddd, MMM Do');
                                                                    prepare_by_time = moment(dateTimeInUtc, "YYYY-MM-DD HH:mm:ss").format('h:mm A');
                                                                } else {
                                                                    prepare_by_date = moment.utc(dateTimeInUtc).local().format('ddd, MMM Do');
                                                                    prepare_by_time = moment.utc(dateTimeInUtc).local().format('h:mm A');
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        })

                                        if (timeZone !== undefined && timeZone !== "" && timeZone !== null) {
                                            if (onlineOrderFormType === "jotform") {
                                                timeZone = timeZone.split(' ')[0]
                                                var dateTimeInUtc = momentTz.tz(this.state.order[index].created_at, "YYYY-MM-DD HH:mm:ss", "America/New_York").utc().format("YYYY-MM-DD HH:mm:ss");
                                                created_date = moment.utc(dateTimeInUtc, "YYYY-MM-DD HH:mm:ss").tz(timeZone).format('ddd, MMM Do');
                                                created_time = moment.utc(dateTimeInUtc, "YYYY-MM-DD HH:mm:ss").tz(timeZone).format('h:mm A');
                                            } else {
                                                created_date = moment.utc(this.state.order[index].created_at).local().format('ddd, MMM Do');
                                                created_time = moment.utc(this.state.order[index].created_at).local().format('h:mm A');
                                            }
                                        } else {
                                            if (onlineOrderFormType === "jotform") {
                                                created_date = moment.utc(this.state.order[index].created_at).format('ddd, MMM Do');
                                                created_time = moment.utc(this.state.order[index].created_at).format('h:mm A');
                                            } else {
                                                created_date = moment.utc(this.state.order[index].created_at).local().format('ddd, MMM Do');
                                                created_time = moment.utc(this.state.order[index].created_at).local().format('h:mm A');
                                            }
                                        }

                                        if (onlineOrderFormType === "wordpress" && prepare_by_date === "" && prepare_by_time === "-" && created_date !== "" && created_time !== "") {
                                            let dateTime = moment(created_date + ' ' + created_time, 'ddd, MMM Do h:mm A')
                                            prepare_by_date = moment(dateTime, 'ddd, MMM Do h:mm A').format('ddd, MMM Do')
                                            prepare_by_time = moment(dateTime, 'ddd, MMM Do h:mm A').add(30, 'minutes').format('h:mm A');
                                        }

                                        if (onlineOrderFormType === "wordpress" && this.state.order[index].refund_status !== undefined && this.state.order[index].refund_status !== "") {
                                            refundStatus = this.state.order[index].refund_status
                                        }

                                        return (
                                            <TableRow className={classes.tableRow}
                                                      style={index % 2 ? {background: "#fff0f5"} : {background: "white"}}>
                                                <TableCell className={classes.tableCell} style={{fontWeight: '700'}}>
                                                    {customer}
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                    <div className="date-Div">
                                                        <p style={{fontWeight: '700'}}>
                                                            {created_time}
                                                        </p>
                                                        <p style={{color: '#808080'}}>
                                                            {created_date}
                                                        </p>
                                                    </div>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                    <div className={classes.preparebyWithEditDiv}>
                                                        <div className="date-Div">
                                                            <p style={{fontWeight: '700'}}>
                                                                {prepare_by_time}
                                                            </p>
                                                            <p style={{color: '#808080'}}>
                                                                {prepare_by_date}
                                                            </p>
                                                        </div>
                                                        {isActiveOrCompleted === "Active" || isActiveOrCompleted === "processing" ?
                                                            <div style={{float: 'right', width: '10%'}}>
                                                                <IconButton onClick={() => this.openDatePicker(index)}
                                                                            id={[index]}
                                                                            style={{marginLeft: '-15px'}}>
                                                                    <EditIcon fontSize="large"/>
                                                                </IconButton>
                                                                {/*<span>*/}
                                                                {/*    Send*/}
                                                                {/*</span>*/}
                                                            </div> : ""
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell className={classes.tableCell} style={{fontWeight: '700'}}>
                                                    {orderType}
                                                </TableCell>
                                                <TableCell className={classes.tableCell} style={{fontWeight: '700'}}>
                                                    <div>
                                                        <p style={{fontWeight: '700',marginTop:'10px'}}>
                                                            {total ? total : "-"}
                                                        </p>
                                                        {onlineOrderFormType !== "jotform" && refundStatus !== "wc-failed" ?
                                                            refundStatus === "wc-refunded" ?
                                                                <IconButton style={{color: '#F03A55', marginTop:'-15px'}}>
                                                                    Refunded
                                                                </IconButton>
                                                                :
                                                                <IconButton onClick={(e) => this.refundClicked(index, e)}
                                                                            id={[index]}
                                                                            style={{color: '#3090C7', marginTop:'-15px'}}>
                                                                    Refund
                                                                </IconButton>
                                                            : ""
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell className={classes.tableCell}>
                                                    <div className="sidebar-social">
                                                        <ul>
                                                            <li>
                                                                <IconButton
                                                                    onClick={(e) => this.showRightSideView(index, e)}
                                                                    id={[index]}>
                                                                    <img
                                                                        src={require('../../../images/orderIcons/order_details.png')}
                                                                        className="details-print-complete-button"/>
                                                                </IconButton>
                                                                <span>
                                                    Details
                                                </span>
                                                            </li>
                                                            <li>
                                                                <IconButton
                                                                    onClick={() => this.customerPrintReceipt(index)}>
                                                                    <img
                                                                        src={require('../../../images/orderIcons/order_receipt.png')}
                                                                        className="details-print-complete-button"/>
                                                                </IconButton>
                                                                <span>
                                                    Receipt
                                                </span>

                                                            </li>
                                                            {/*<li>*/}
                                                            {/*    <IconButton onClick={() => this.kitchenPrintReceipt(index)}>*/}
                                                            {/*        <img*/}
                                                            {/*            src={require('../../../images/orderIcons/order_send.png')}*/}
                                                            {/*            className="details-print-complete-button"/>*/}
                                                            {/*    </IconButton>*/}
                                                            {/*    <span>*/}
                                                            {/*    Send*/}
                                                            {/*</span>*/}

                                                            {/*</li>*/}
                                                            {isActiveOrCompleted === "Active" || isActiveOrCompleted === "processing" ?
                                                                <li>
                                                                    <IconButton
                                                                        onClick={(e) => this.markAsCompleteOrderClicked(index, e)}
                                                                        id={[index]}>
                                                                        <img
                                                                            src={require('../../../images/orderIcons/order_complete.png')}
                                                                            className="details-print-complete-button"/>
                                                                    </IconButton>
                                                                    <span>
                                                        Complete
                                                    </span>

                                                                </li>
                                                                : isActiveOrCompleted === "Cancelled" ?
                                                                    <li>
                                                                        <IconButton>
                                                                            <img
                                                                                src={require('../../../images/orderIcons/order_cancel.png')}
                                                                                className="details-print-complete-button"/>
                                                                        </IconButton>
                                                                        <span style={{color: '#F03A55'}}>
                                                            Cancelled
                                                        </span>
                                                                    </li>
                                                                    :
                                                                    <li>
                                                                        <IconButton>
                                                                            <img
                                                                                src={require('../../../images/orderIcons/order_complete_green.png')}
                                                                                className="details-print-complete-button"/>
                                                                        </IconButton>
                                                                        <span style={{color: '#4CAF50'}}>
                                                            Completed
                                                        </span>
                                                                    </li>
                                                            }
                                                            {orderType !== "Delivery" && orderType !== "DoorDash Delivery" ?
                                                                isNotifiedUser === "Yes" ?
                                                                    <li>
                                                                        <IconButton disabled>
                                                                            <img
                                                                                src={require('../../../images/orderIcons/order_notify_green.png')}
                                                                                className="details-print-complete-button"/>
                                                                        </IconButton>
                                                                        <span style={{color: '#4CAF50'}}>
                                                                    Notified
                                                                </span>
                                                                    </li>
                                                                    : <li>
                                                                        <IconButton
                                                                            onClick={(e) => this.callSendMessageApi(index, e)}
                                                                            id={[index]}>
                                                                            <img
                                                                                src={require('../../../images/orderIcons/order_notify.png')}
                                                                                className="details-print-complete-button"/>
                                                                        </IconButton>
                                                                        <span>
                                                            Notify
                                                        </span>
                                                                    </li>
                                                                : ""
                                                            }
                                                        </ul>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                })
                                }
                            </TableBody>
                            {(this.props.user.BusinessUser.OnlineOrderFormType !== "jotform") && this.state.order && this.state.order.length > 0 ?
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            count={size}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            rowsPerPageOptions={[]}
                                            onChangePage={this.handleChangePage}
                                            ActionsComponent={TablePaginationActionsWrapped}
                                        />
                                    </TableRow>
                                </TableFooter> : ""
                            }
                        </Table>
                    </div>
                }

                {
                    ((this.props.user.BusinessUser.OnlineOrderFormType !== "jotform") && this.state.order === undefined) ? <center><Loader/></center>
                        :
                        <div></div>
                }
            </div>
        )
    }
}

const mapStateToProps=(state)=> {
    return {
        order:state.orderReducer.order,
        user:state.loginResponse.results,
        orderReducer: state.orderReducer
    }
};

const matchDispatchToProps=(dispatch)=> {
    return bindActionCreators({
        getOrder,
        deleteOrder,
        updateOrder,
        sendMail,
        sendMessage,
        saveOnlineOrderMessage,
        printReceipt,
        stripeRefund
    },dispatch)
};

export default connect(mapStateToProps,matchDispatchToProps)(withStyles(styles)(OrdersTable));
